var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// gen/sqlynx/proto/index.ts
var proto_exports = {};
__export(proto_exports, {
  AConstType: () => AConstType,
  AnalyzedScript: () => AnalyzedScript,
  AnalyzedScriptT: () => AnalyzedScriptT,
  AttributeKey: () => AttributeKey,
  CatalogEntries: () => CatalogEntries,
  CatalogEntriesT: () => CatalogEntriesT,
  CatalogEntry: () => CatalogEntry,
  CatalogEntryT: () => CatalogEntryT,
  CatalogEntryType: () => CatalogEntryType,
  CharacterType: () => CharacterType,
  ColumnConstraint: () => ColumnConstraint,
  ColumnReference: () => ColumnReference,
  ColumnReferenceT: () => ColumnReferenceT,
  CombineModifier: () => CombineModifier,
  CombineOperation: () => CombineOperation,
  Completion: () => Completion,
  CompletionCandidate: () => CompletionCandidate,
  CompletionCandidateT: () => CompletionCandidateT,
  CompletionStrategy: () => CompletionStrategy,
  CompletionT: () => CompletionT,
  ConstraintAttribute: () => ConstraintAttribute,
  Error: () => Error2,
  ErrorT: () => ErrorT,
  ExpressionOperator: () => ExpressionOperator,
  ExtractTarget: () => ExtractTarget,
  GroupByItemType: () => GroupByItemType,
  IntervalType: () => IntervalType,
  JoinType: () => JoinType,
  KeyActionCommand: () => KeyActionCommand,
  KeyActionTrigger: () => KeyActionTrigger,
  KeyMatch: () => KeyMatch,
  KnownFunction: () => KnownFunction,
  Location: () => Location,
  LocationT: () => LocationT,
  NameTag: () => NameTag,
  Node: () => Node,
  NodeT: () => NodeT,
  NodeType: () => NodeType,
  NumericType: () => NumericType,
  OnCommitOption: () => OnCommitOption,
  OrderDirection: () => OrderDirection,
  OrderNullRule: () => OrderNullRule,
  ParsedScript: () => ParsedScript,
  ParsedScriptT: () => ParsedScriptT,
  QualifiedColumnName: () => QualifiedColumnName,
  QualifiedColumnNameT: () => QualifiedColumnNameT,
  QualifiedTableName: () => QualifiedTableName,
  QualifiedTableNameT: () => QualifiedTableNameT,
  QueryGraphEdge: () => QueryGraphEdge,
  QueryGraphEdgeNode: () => QueryGraphEdgeNode,
  QueryGraphEdgeNodeT: () => QueryGraphEdgeNodeT,
  QueryGraphEdgeT: () => QueryGraphEdgeT,
  QueryGraphLayout: () => QueryGraphLayout,
  QueryGraphLayoutEdge: () => QueryGraphLayoutEdge,
  QueryGraphLayoutEdgeNode: () => QueryGraphLayoutEdgeNode,
  QueryGraphLayoutEdgeNodeT: () => QueryGraphLayoutEdgeNodeT,
  QueryGraphLayoutEdgeT: () => QueryGraphLayoutEdgeT,
  QueryGraphLayoutT: () => QueryGraphLayoutT,
  QueryGraphLayoutTableNode: () => QueryGraphLayoutTableNode,
  QueryGraphLayoutTableNodeT: () => QueryGraphLayoutTableNodeT,
  QueryGraphLayoutVertex: () => QueryGraphLayoutVertex,
  QueryGraphLayoutVertexT: () => QueryGraphLayoutVertexT,
  RelativeSymbolPosition: () => RelativeSymbolPosition,
  RowLockingBlockBehavior: () => RowLockingBlockBehavior,
  RowLockingStrength: () => RowLockingStrength,
  SampleCountUnit: () => SampleCountUnit,
  ScannedScript: () => ScannedScript,
  ScannedScriptT: () => ScannedScriptT,
  ScannerTokenType: () => ScannerTokenType,
  ScannerTokens: () => ScannerTokens,
  ScannerTokensT: () => ScannerTokensT,
  SchemaDescriptor: () => SchemaDescriptor,
  SchemaDescriptorT: () => SchemaDescriptorT,
  SchemaTable: () => SchemaTable,
  SchemaTableColumn: () => SchemaTableColumn,
  SchemaTableColumnT: () => SchemaTableColumnT,
  SchemaTableT: () => SchemaTableT,
  ScriptCursorInfo: () => ScriptCursorInfo,
  ScriptCursorInfoT: () => ScriptCursorInfoT,
  ScriptMemoryStatistics: () => ScriptMemoryStatistics,
  ScriptMemoryStatisticsT: () => ScriptMemoryStatisticsT,
  ScriptProcessingMemoryStatistics: () => ScriptProcessingMemoryStatistics,
  ScriptProcessingMemoryStatisticsT: () => ScriptProcessingMemoryStatisticsT,
  ScriptProcessingTimings: () => ScriptProcessingTimings,
  ScriptProcessingTimingsT: () => ScriptProcessingTimingsT,
  ScriptStatistics: () => ScriptStatistics,
  ScriptStatisticsT: () => ScriptStatisticsT,
  Statement: () => Statement,
  StatementT: () => StatementT,
  StatementType: () => StatementType,
  StatusCode: () => StatusCode,
  SubqueryQuantifier: () => SubqueryQuantifier,
  Table: () => Table,
  TableColumn: () => TableColumn,
  TableColumnT: () => TableColumnT,
  TableConstraint: () => TableConstraint,
  TableReference: () => TableReference,
  TableReferenceT: () => TableReferenceT,
  TableT: () => TableT,
  TempType: () => TempType,
  TrimDirection: () => TrimDirection,
  WindowBoundDirection: () => WindowBoundDirection,
  WindowBoundMode: () => WindowBoundMode,
  WindowExclusionMode: () => WindowExclusionMode,
  WindowRangeMode: () => WindowRangeMode
});

// gen/sqlynx/proto/aconst-type.ts
var AConstType = /* @__PURE__ */ ((AConstType2) => {
  AConstType2[AConstType2["NULL_"] = 0] = "NULL_";
  AConstType2[AConstType2["INTEGER"] = 1] = "INTEGER";
  AConstType2[AConstType2["FLOAT"] = 2] = "FLOAT";
  AConstType2[AConstType2["STRING"] = 3] = "STRING";
  AConstType2[AConstType2["INTERVAL"] = 5] = "INTERVAL";
  return AConstType2;
})(AConstType || {});

// gen/sqlynx/proto/analyzed-script.ts
import * as flatbuffers7 from "flatbuffers";

// gen/sqlynx/proto/column-reference.ts
import * as flatbuffers2 from "flatbuffers";

// gen/sqlynx/proto/qualified-column-name.ts
import * as flatbuffers from "flatbuffers";
var QualifiedColumnName = class _QualifiedColumnName {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsQualifiedColumnName(bb, obj) {
    return (obj || new _QualifiedColumnName()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsQualifiedColumnName(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new _QualifiedColumnName()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  tableAlias(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  columnName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QualifiedColumnName";
  }
  static startQualifiedColumnName(builder) {
    builder.startObject(3);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(0, astNodeId, 0);
  }
  static addTableAlias(builder, tableAliasOffset) {
    builder.addFieldOffset(1, tableAliasOffset, 0);
  }
  static addColumnName(builder, columnNameOffset) {
    builder.addFieldOffset(2, columnNameOffset, 0);
  }
  static endQualifiedColumnName(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createQualifiedColumnName(builder, astNodeId, tableAliasOffset, columnNameOffset) {
    _QualifiedColumnName.startQualifiedColumnName(builder);
    _QualifiedColumnName.addAstNodeId(builder, astNodeId);
    _QualifiedColumnName.addTableAlias(builder, tableAliasOffset);
    _QualifiedColumnName.addColumnName(builder, columnNameOffset);
    return _QualifiedColumnName.endQualifiedColumnName(builder);
  }
  unpack() {
    return new QualifiedColumnNameT(
      this.astNodeId(),
      this.tableAlias(),
      this.columnName()
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.tableAlias = this.tableAlias();
    _o.columnName = this.columnName();
  }
};
var QualifiedColumnNameT = class {
  constructor(astNodeId = 0, tableAlias = null, columnName = null) {
    this.astNodeId = astNodeId;
    this.tableAlias = tableAlias;
    this.columnName = columnName;
  }
  pack(builder) {
    const tableAlias = this.tableAlias !== null ? builder.createString(this.tableAlias) : 0;
    const columnName = this.columnName !== null ? builder.createString(this.columnName) : 0;
    return QualifiedColumnName.createQualifiedColumnName(
      builder,
      this.astNodeId,
      tableAlias,
      columnName
    );
  }
};

// gen/sqlynx/proto/column-reference.ts
var ColumnReference = class _ColumnReference {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsColumnReference(bb, obj) {
    return (obj || new _ColumnReference()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsColumnReference(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers2.SIZE_PREFIX_LENGTH);
    return (obj || new _ColumnReference()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  astStatementId() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_statement_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  astScopeRoot() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_scope_root(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  columnName(obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new QualifiedColumnName()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
  }
  resolvedTableReferenceId() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt("0");
  }
  mutate_resolved_table_reference_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint64(this.bb_pos + offset, value);
    return true;
  }
  resolvedTableId() {
    const offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt("0");
  }
  mutate_resolved_table_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 14);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint64(this.bb_pos + offset, value);
    return true;
  }
  resolvedColumnId() {
    const offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_resolved_column_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 16);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ColumnReference";
  }
  static startColumnReference(builder) {
    builder.startObject(7);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(0, astNodeId, 0);
  }
  static addAstStatementId(builder, astStatementId) {
    builder.addFieldInt32(1, astStatementId, 0);
  }
  static addAstScopeRoot(builder, astScopeRoot) {
    builder.addFieldInt32(2, astScopeRoot, 0);
  }
  static addColumnName(builder, columnNameOffset) {
    builder.addFieldOffset(3, columnNameOffset, 0);
  }
  static addResolvedTableReferenceId(builder, resolvedTableReferenceId) {
    builder.addFieldInt64(4, resolvedTableReferenceId, BigInt("0"));
  }
  static addResolvedTableId(builder, resolvedTableId) {
    builder.addFieldInt64(5, resolvedTableId, BigInt("0"));
  }
  static addResolvedColumnId(builder, resolvedColumnId) {
    builder.addFieldInt32(6, resolvedColumnId, 0);
  }
  static endColumnReference(builder) {
    const offset = builder.endObject();
    return offset;
  }
  unpack() {
    return new ColumnReferenceT(
      this.astNodeId(),
      this.astStatementId(),
      this.astScopeRoot(),
      this.columnName() !== null ? this.columnName().unpack() : null,
      this.resolvedTableReferenceId(),
      this.resolvedTableId(),
      this.resolvedColumnId()
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.astStatementId = this.astStatementId();
    _o.astScopeRoot = this.astScopeRoot();
    _o.columnName = this.columnName() !== null ? this.columnName().unpack() : null;
    _o.resolvedTableReferenceId = this.resolvedTableReferenceId();
    _o.resolvedTableId = this.resolvedTableId();
    _o.resolvedColumnId = this.resolvedColumnId();
  }
};
var ColumnReferenceT = class {
  constructor(astNodeId = 0, astStatementId = 0, astScopeRoot = 0, columnName = null, resolvedTableReferenceId = BigInt("0"), resolvedTableId = BigInt("0"), resolvedColumnId = 0) {
    this.astNodeId = astNodeId;
    this.astStatementId = astStatementId;
    this.astScopeRoot = astScopeRoot;
    this.columnName = columnName;
    this.resolvedTableReferenceId = resolvedTableReferenceId;
    this.resolvedTableId = resolvedTableId;
    this.resolvedColumnId = resolvedColumnId;
  }
  pack(builder) {
    const columnName = this.columnName !== null ? this.columnName.pack(builder) : 0;
    ColumnReference.startColumnReference(builder);
    ColumnReference.addAstNodeId(builder, this.astNodeId);
    ColumnReference.addAstStatementId(builder, this.astStatementId);
    ColumnReference.addAstScopeRoot(builder, this.astScopeRoot);
    ColumnReference.addColumnName(builder, columnName);
    ColumnReference.addResolvedTableReferenceId(builder, this.resolvedTableReferenceId);
    ColumnReference.addResolvedTableId(builder, this.resolvedTableId);
    ColumnReference.addResolvedColumnId(builder, this.resolvedColumnId);
    return ColumnReference.endColumnReference(builder);
  }
};

// gen/sqlynx/proto/expression-operator.ts
var ExpressionOperator = /* @__PURE__ */ ((ExpressionOperator2) => {
  ExpressionOperator2[ExpressionOperator2["DEFAULT"] = 0] = "DEFAULT";
  ExpressionOperator2[ExpressionOperator2["NEGATE"] = 1] = "NEGATE";
  ExpressionOperator2[ExpressionOperator2["NOT"] = 2] = "NOT";
  ExpressionOperator2[ExpressionOperator2["TYPECAST"] = 3] = "TYPECAST";
  ExpressionOperator2[ExpressionOperator2["COLLATE"] = 4] = "COLLATE";
  ExpressionOperator2[ExpressionOperator2["AT_TIMEZONE"] = 5] = "AT_TIMEZONE";
  ExpressionOperator2[ExpressionOperator2["PLUS"] = 6] = "PLUS";
  ExpressionOperator2[ExpressionOperator2["MINUS"] = 7] = "MINUS";
  ExpressionOperator2[ExpressionOperator2["MULTIPLY"] = 8] = "MULTIPLY";
  ExpressionOperator2[ExpressionOperator2["DIVIDE"] = 9] = "DIVIDE";
  ExpressionOperator2[ExpressionOperator2["MODULUS"] = 10] = "MODULUS";
  ExpressionOperator2[ExpressionOperator2["AND"] = 11] = "AND";
  ExpressionOperator2[ExpressionOperator2["OR"] = 12] = "OR";
  ExpressionOperator2[ExpressionOperator2["XOR"] = 13] = "XOR";
  ExpressionOperator2[ExpressionOperator2["GLOB"] = 14] = "GLOB";
  ExpressionOperator2[ExpressionOperator2["NOT_GLOB"] = 15] = "NOT_GLOB";
  ExpressionOperator2[ExpressionOperator2["IS_NULL"] = 16] = "IS_NULL";
  ExpressionOperator2[ExpressionOperator2["LIKE"] = 17] = "LIKE";
  ExpressionOperator2[ExpressionOperator2["ILIKE"] = 18] = "ILIKE";
  ExpressionOperator2[ExpressionOperator2["SIMILAR_TO"] = 19] = "SIMILAR_TO";
  ExpressionOperator2[ExpressionOperator2["NOT_NULL"] = 20] = "NOT_NULL";
  ExpressionOperator2[ExpressionOperator2["NOT_LIKE"] = 21] = "NOT_LIKE";
  ExpressionOperator2[ExpressionOperator2["NOT_ILIKE"] = 22] = "NOT_ILIKE";
  ExpressionOperator2[ExpressionOperator2["NOT_SIMILAR_TO"] = 23] = "NOT_SIMILAR_TO";
  ExpressionOperator2[ExpressionOperator2["IS_TRUE"] = 24] = "IS_TRUE";
  ExpressionOperator2[ExpressionOperator2["IS_FALSE"] = 25] = "IS_FALSE";
  ExpressionOperator2[ExpressionOperator2["IS_UNKNOWN"] = 26] = "IS_UNKNOWN";
  ExpressionOperator2[ExpressionOperator2["IS_DISTINCT_FROM"] = 27] = "IS_DISTINCT_FROM";
  ExpressionOperator2[ExpressionOperator2["IS_OF"] = 28] = "IS_OF";
  ExpressionOperator2[ExpressionOperator2["IS_NOT_TRUE"] = 29] = "IS_NOT_TRUE";
  ExpressionOperator2[ExpressionOperator2["IS_NOT_FALSE"] = 30] = "IS_NOT_FALSE";
  ExpressionOperator2[ExpressionOperator2["IS_NOT_UNKNOWN"] = 31] = "IS_NOT_UNKNOWN";
  ExpressionOperator2[ExpressionOperator2["IS_NOT_DISTINCT_FROM"] = 32] = "IS_NOT_DISTINCT_FROM";
  ExpressionOperator2[ExpressionOperator2["IS_NOT_OF"] = 33] = "IS_NOT_OF";
  ExpressionOperator2[ExpressionOperator2["EQUAL"] = 34] = "EQUAL";
  ExpressionOperator2[ExpressionOperator2["NOT_EQUAL"] = 35] = "NOT_EQUAL";
  ExpressionOperator2[ExpressionOperator2["GREATER_EQUAL"] = 36] = "GREATER_EQUAL";
  ExpressionOperator2[ExpressionOperator2["GREATER_THAN"] = 37] = "GREATER_THAN";
  ExpressionOperator2[ExpressionOperator2["LESS_EQUAL"] = 38] = "LESS_EQUAL";
  ExpressionOperator2[ExpressionOperator2["LESS_THAN"] = 39] = "LESS_THAN";
  ExpressionOperator2[ExpressionOperator2["BETWEEN_SYMMETRIC"] = 40] = "BETWEEN_SYMMETRIC";
  ExpressionOperator2[ExpressionOperator2["BETWEEN_ASYMMETRIC"] = 41] = "BETWEEN_ASYMMETRIC";
  ExpressionOperator2[ExpressionOperator2["NOT_BETWEEN_SYMMETRIC"] = 42] = "NOT_BETWEEN_SYMMETRIC";
  ExpressionOperator2[ExpressionOperator2["NOT_BETWEEN_ASYMMETRIC"] = 43] = "NOT_BETWEEN_ASYMMETRIC";
  ExpressionOperator2[ExpressionOperator2["IN"] = 44] = "IN";
  ExpressionOperator2[ExpressionOperator2["NOT_IN"] = 45] = "NOT_IN";
  ExpressionOperator2[ExpressionOperator2["OVERLAPS"] = 46] = "OVERLAPS";
  return ExpressionOperator2;
})(ExpressionOperator || {});

// gen/sqlynx/proto/query-graph-edge.ts
var QueryGraphEdge = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The id of the AST node that created this graph node
   */
  astNodeId() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_ast_node_id(value) {
    this.bb.writeUint32(this.bb_pos + 0, value);
    return true;
  }
  /**
   * The begin of the nodes
   */
  nodesBegin() {
    return this.bb.readUint32(this.bb_pos + 4);
  }
  mutate_nodes_begin(value) {
    this.bb.writeUint32(this.bb_pos + 4, value);
    return true;
  }
  /**
   * The number of nodes on the left side
   */
  nodeCountLeft() {
    return this.bb.readUint16(this.bb_pos + 8);
  }
  mutate_node_count_left(value) {
    this.bb.writeUint16(this.bb_pos + 8, value);
    return true;
  }
  /**
   * The set id of nodes on the right side
   */
  nodeCountRight() {
    return this.bb.readUint16(this.bb_pos + 10);
  }
  mutate_node_count_right(value) {
    this.bb.writeUint16(this.bb_pos + 10, value);
    return true;
  }
  /**
   * The expression operator
   */
  expressionOperator() {
    return this.bb.readUint8(this.bb_pos + 12);
  }
  mutate_expression_operator(value) {
    this.bb.writeUint8(this.bb_pos + 12, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphEdge";
  }
  static sizeOf() {
    return 16;
  }
  static createQueryGraphEdge(builder, ast_node_id, nodes_begin, node_count_left, node_count_right, expression_operator) {
    builder.prep(4, 16);
    builder.pad(3);
    builder.writeInt8(expression_operator);
    builder.writeInt16(node_count_right);
    builder.writeInt16(node_count_left);
    builder.writeInt32(nodes_begin);
    builder.writeInt32(ast_node_id);
    return builder.offset();
  }
  unpack() {
    return new QueryGraphEdgeT(
      this.astNodeId(),
      this.nodesBegin(),
      this.nodeCountLeft(),
      this.nodeCountRight(),
      this.expressionOperator()
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.nodesBegin = this.nodesBegin();
    _o.nodeCountLeft = this.nodeCountLeft();
    _o.nodeCountRight = this.nodeCountRight();
    _o.expressionOperator = this.expressionOperator();
  }
};
var QueryGraphEdgeT = class {
  constructor(astNodeId = 0, nodesBegin = 0, nodeCountLeft = 0, nodeCountRight = 0, expressionOperator = 0 /* DEFAULT */) {
    this.astNodeId = astNodeId;
    this.nodesBegin = nodesBegin;
    this.nodeCountLeft = nodeCountLeft;
    this.nodeCountRight = nodeCountRight;
    this.expressionOperator = expressionOperator;
  }
  pack(builder) {
    return QueryGraphEdge.createQueryGraphEdge(
      builder,
      this.astNodeId,
      this.nodesBegin,
      this.nodeCountLeft,
      this.nodeCountRight,
      this.expressionOperator
    );
  }
};

// gen/sqlynx/proto/query-graph-edge-node.ts
var QueryGraphEdgeNode = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The id of the column reference
   */
  columnReferenceId() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_column_reference_id(value) {
    this.bb.writeUint32(this.bb_pos + 0, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphEdgeNode";
  }
  static sizeOf() {
    return 4;
  }
  static createQueryGraphEdgeNode(builder, column_reference_id) {
    builder.prep(4, 4);
    builder.writeInt32(column_reference_id);
    return builder.offset();
  }
  unpack() {
    return new QueryGraphEdgeNodeT(
      this.columnReferenceId()
    );
  }
  unpackTo(_o) {
    _o.columnReferenceId = this.columnReferenceId();
  }
};
var QueryGraphEdgeNodeT = class {
  constructor(columnReferenceId = 0) {
    this.columnReferenceId = columnReferenceId;
  }
  pack(builder) {
    return QueryGraphEdgeNode.createQueryGraphEdgeNode(
      builder,
      this.columnReferenceId
    );
  }
};

// gen/sqlynx/proto/table.ts
import * as flatbuffers5 from "flatbuffers";

// gen/sqlynx/proto/qualified-table-name.ts
import * as flatbuffers3 from "flatbuffers";
var QualifiedTableName = class _QualifiedTableName {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsQualifiedTableName(bb, obj) {
    return (obj || new _QualifiedTableName()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsQualifiedTableName(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers3.SIZE_PREFIX_LENGTH);
    return (obj || new _QualifiedTableName()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  databaseName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  schemaName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  tableName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QualifiedTableName";
  }
  static startQualifiedTableName(builder) {
    builder.startObject(4);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(0, astNodeId, 0);
  }
  static addDatabaseName(builder, databaseNameOffset) {
    builder.addFieldOffset(1, databaseNameOffset, 0);
  }
  static addSchemaName(builder, schemaNameOffset) {
    builder.addFieldOffset(2, schemaNameOffset, 0);
  }
  static addTableName(builder, tableNameOffset) {
    builder.addFieldOffset(3, tableNameOffset, 0);
  }
  static endQualifiedTableName(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createQualifiedTableName(builder, astNodeId, databaseNameOffset, schemaNameOffset, tableNameOffset) {
    _QualifiedTableName.startQualifiedTableName(builder);
    _QualifiedTableName.addAstNodeId(builder, astNodeId);
    _QualifiedTableName.addDatabaseName(builder, databaseNameOffset);
    _QualifiedTableName.addSchemaName(builder, schemaNameOffset);
    _QualifiedTableName.addTableName(builder, tableNameOffset);
    return _QualifiedTableName.endQualifiedTableName(builder);
  }
  unpack() {
    return new QualifiedTableNameT(
      this.astNodeId(),
      this.databaseName(),
      this.schemaName(),
      this.tableName()
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.databaseName = this.databaseName();
    _o.schemaName = this.schemaName();
    _o.tableName = this.tableName();
  }
};
var QualifiedTableNameT = class {
  constructor(astNodeId = 0, databaseName = null, schemaName = null, tableName = null) {
    this.astNodeId = astNodeId;
    this.databaseName = databaseName;
    this.schemaName = schemaName;
    this.tableName = tableName;
  }
  pack(builder) {
    const databaseName = this.databaseName !== null ? builder.createString(this.databaseName) : 0;
    const schemaName = this.schemaName !== null ? builder.createString(this.schemaName) : 0;
    const tableName = this.tableName !== null ? builder.createString(this.tableName) : 0;
    return QualifiedTableName.createQualifiedTableName(
      builder,
      this.astNodeId,
      databaseName,
      schemaName,
      tableName
    );
  }
};

// gen/sqlynx/proto/table-column.ts
import * as flatbuffers4 from "flatbuffers";
var TableColumn = class _TableColumn {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsTableColumn(bb, obj) {
    return (obj || new _TableColumn()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsTableColumn(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers4.SIZE_PREFIX_LENGTH);
    return (obj || new _TableColumn()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  columnName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.TableColumn";
  }
  static startTableColumn(builder) {
    builder.startObject(2);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(0, astNodeId, 0);
  }
  static addColumnName(builder, columnNameOffset) {
    builder.addFieldOffset(1, columnNameOffset, 0);
  }
  static endTableColumn(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createTableColumn(builder, astNodeId, columnNameOffset) {
    _TableColumn.startTableColumn(builder);
    _TableColumn.addAstNodeId(builder, astNodeId);
    _TableColumn.addColumnName(builder, columnNameOffset);
    return _TableColumn.endTableColumn(builder);
  }
  unpack() {
    return new TableColumnT(
      this.astNodeId(),
      this.columnName()
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.columnName = this.columnName();
  }
};
var TableColumnT = class {
  constructor(astNodeId = 0, columnName = null) {
    this.astNodeId = astNodeId;
    this.columnName = columnName;
  }
  pack(builder) {
    const columnName = this.columnName !== null ? builder.createString(this.columnName) : 0;
    return TableColumn.createTableColumn(
      builder,
      this.astNodeId,
      columnName
    );
  }
};

// gen/sqlynx/proto/table.ts
var Table = class _Table {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsTable(bb, obj) {
    return (obj || new _Table()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsTable(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers5.SIZE_PREFIX_LENGTH);
    return (obj || new _Table()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  astStatementId() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_statement_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  astScopeRoot() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_scope_root(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  tableName(obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new QualifiedTableName()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
  }
  tableColumns(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? (obj || new TableColumn()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  tableColumnsLength() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.Table";
  }
  static startTable(builder) {
    builder.startObject(5);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(0, astNodeId, 0);
  }
  static addAstStatementId(builder, astStatementId) {
    builder.addFieldInt32(1, astStatementId, 0);
  }
  static addAstScopeRoot(builder, astScopeRoot) {
    builder.addFieldInt32(2, astScopeRoot, 0);
  }
  static addTableName(builder, tableNameOffset) {
    builder.addFieldOffset(3, tableNameOffset, 0);
  }
  static addTableColumns(builder, tableColumnsOffset) {
    builder.addFieldOffset(4, tableColumnsOffset, 0);
  }
  static createTableColumnsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startTableColumnsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endTable(builder) {
    const offset = builder.endObject();
    return offset;
  }
  unpack() {
    return new TableT(
      this.astNodeId(),
      this.astStatementId(),
      this.astScopeRoot(),
      this.tableName() !== null ? this.tableName().unpack() : null,
      this.bb.createObjList(this.tableColumns.bind(this), this.tableColumnsLength())
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.astStatementId = this.astStatementId();
    _o.astScopeRoot = this.astScopeRoot();
    _o.tableName = this.tableName() !== null ? this.tableName().unpack() : null;
    _o.tableColumns = this.bb.createObjList(this.tableColumns.bind(this), this.tableColumnsLength());
  }
};
var TableT = class {
  constructor(astNodeId = 0, astStatementId = 0, astScopeRoot = 0, tableName = null, tableColumns = []) {
    this.astNodeId = astNodeId;
    this.astStatementId = astStatementId;
    this.astScopeRoot = astScopeRoot;
    this.tableName = tableName;
    this.tableColumns = tableColumns;
  }
  pack(builder) {
    const tableName = this.tableName !== null ? this.tableName.pack(builder) : 0;
    const tableColumns = Table.createTableColumnsVector(builder, builder.createObjectOffsetList(this.tableColumns));
    Table.startTable(builder);
    Table.addAstNodeId(builder, this.astNodeId);
    Table.addAstStatementId(builder, this.astStatementId);
    Table.addAstScopeRoot(builder, this.astScopeRoot);
    Table.addTableName(builder, tableName);
    Table.addTableColumns(builder, tableColumns);
    return Table.endTable(builder);
  }
};

// gen/sqlynx/proto/table-reference.ts
import * as flatbuffers6 from "flatbuffers";
var TableReference = class _TableReference {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsTableReference(bb, obj) {
    return (obj || new _TableReference()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsTableReference(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers6.SIZE_PREFIX_LENGTH);
    return (obj || new _TableReference()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  astStatementId() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_statement_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  astScopeRoot() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_scope_root(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  tableName(obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new QualifiedTableName()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
  }
  aliasName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  resolvedTableId() {
    const offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt("0");
  }
  mutate_resolved_table_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 14);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint64(this.bb_pos + offset, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.TableReference";
  }
  static startTableReference(builder) {
    builder.startObject(6);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(0, astNodeId, 0);
  }
  static addAstStatementId(builder, astStatementId) {
    builder.addFieldInt32(1, astStatementId, 0);
  }
  static addAstScopeRoot(builder, astScopeRoot) {
    builder.addFieldInt32(2, astScopeRoot, 0);
  }
  static addTableName(builder, tableNameOffset) {
    builder.addFieldOffset(3, tableNameOffset, 0);
  }
  static addAliasName(builder, aliasNameOffset) {
    builder.addFieldOffset(4, aliasNameOffset, 0);
  }
  static addResolvedTableId(builder, resolvedTableId) {
    builder.addFieldInt64(5, resolvedTableId, BigInt("0"));
  }
  static endTableReference(builder) {
    const offset = builder.endObject();
    return offset;
  }
  unpack() {
    return new TableReferenceT(
      this.astNodeId(),
      this.astStatementId(),
      this.astScopeRoot(),
      this.tableName() !== null ? this.tableName().unpack() : null,
      this.aliasName(),
      this.resolvedTableId()
    );
  }
  unpackTo(_o) {
    _o.astNodeId = this.astNodeId();
    _o.astStatementId = this.astStatementId();
    _o.astScopeRoot = this.astScopeRoot();
    _o.tableName = this.tableName() !== null ? this.tableName().unpack() : null;
    _o.aliasName = this.aliasName();
    _o.resolvedTableId = this.resolvedTableId();
  }
};
var TableReferenceT = class {
  constructor(astNodeId = 0, astStatementId = 0, astScopeRoot = 0, tableName = null, aliasName = null, resolvedTableId = BigInt("0")) {
    this.astNodeId = astNodeId;
    this.astStatementId = astStatementId;
    this.astScopeRoot = astScopeRoot;
    this.tableName = tableName;
    this.aliasName = aliasName;
    this.resolvedTableId = resolvedTableId;
  }
  pack(builder) {
    const tableName = this.tableName !== null ? this.tableName.pack(builder) : 0;
    const aliasName = this.aliasName !== null ? builder.createString(this.aliasName) : 0;
    TableReference.startTableReference(builder);
    TableReference.addAstNodeId(builder, this.astNodeId);
    TableReference.addAstStatementId(builder, this.astStatementId);
    TableReference.addAstScopeRoot(builder, this.astScopeRoot);
    TableReference.addTableName(builder, tableName);
    TableReference.addAliasName(builder, aliasName);
    TableReference.addResolvedTableId(builder, this.resolvedTableId);
    return TableReference.endTableReference(builder);
  }
};

// gen/sqlynx/proto/analyzed-script.ts
var AnalyzedScript = class _AnalyzedScript {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsAnalyzedScript(bb, obj) {
    return (obj || new _AnalyzedScript()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsAnalyzedScript(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers7.SIZE_PREFIX_LENGTH);
    return (obj || new _AnalyzedScript()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  externalId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_external_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  databaseName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  schemaName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  tables(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new Table()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  tablesLength() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  tableReferences(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? (obj || new TableReference()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  tableReferencesLength() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  columnReferences(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? (obj || new ColumnReference()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  columnReferencesLength() {
    const offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  /**
   * The query graph edges
   */
  graphEdges(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? (obj || new QueryGraphEdge()).__init(this.bb.__vector(this.bb_pos + offset) + index * 16, this.bb) : null;
  }
  graphEdgesLength() {
    const offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  /**
   * The query graph edge nodes
   */
  graphEdgeNodes(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 18);
    return offset ? (obj || new QueryGraphEdgeNode()).__init(this.bb.__vector(this.bb_pos + offset) + index * 4, this.bb) : null;
  }
  graphEdgeNodesLength() {
    const offset = this.bb.__offset(this.bb_pos, 18);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.AnalyzedScript";
  }
  static startAnalyzedScript(builder) {
    builder.startObject(8);
  }
  static addExternalId(builder, externalId) {
    builder.addFieldInt32(0, externalId, 0);
  }
  static addDatabaseName(builder, databaseNameOffset) {
    builder.addFieldOffset(1, databaseNameOffset, 0);
  }
  static addSchemaName(builder, schemaNameOffset) {
    builder.addFieldOffset(2, schemaNameOffset, 0);
  }
  static addTables(builder, tablesOffset) {
    builder.addFieldOffset(3, tablesOffset, 0);
  }
  static createTablesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startTablesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addTableReferences(builder, tableReferencesOffset) {
    builder.addFieldOffset(4, tableReferencesOffset, 0);
  }
  static createTableReferencesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startTableReferencesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addColumnReferences(builder, columnReferencesOffset) {
    builder.addFieldOffset(5, columnReferencesOffset, 0);
  }
  static createColumnReferencesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startColumnReferencesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addGraphEdges(builder, graphEdgesOffset) {
    builder.addFieldOffset(6, graphEdgesOffset, 0);
  }
  static startGraphEdgesVector(builder, numElems) {
    builder.startVector(16, numElems, 4);
  }
  static addGraphEdgeNodes(builder, graphEdgeNodesOffset) {
    builder.addFieldOffset(7, graphEdgeNodesOffset, 0);
  }
  static startGraphEdgeNodesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endAnalyzedScript(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createAnalyzedScript(builder, externalId, databaseNameOffset, schemaNameOffset, tablesOffset, tableReferencesOffset, columnReferencesOffset, graphEdgesOffset, graphEdgeNodesOffset) {
    _AnalyzedScript.startAnalyzedScript(builder);
    _AnalyzedScript.addExternalId(builder, externalId);
    _AnalyzedScript.addDatabaseName(builder, databaseNameOffset);
    _AnalyzedScript.addSchemaName(builder, schemaNameOffset);
    _AnalyzedScript.addTables(builder, tablesOffset);
    _AnalyzedScript.addTableReferences(builder, tableReferencesOffset);
    _AnalyzedScript.addColumnReferences(builder, columnReferencesOffset);
    _AnalyzedScript.addGraphEdges(builder, graphEdgesOffset);
    _AnalyzedScript.addGraphEdgeNodes(builder, graphEdgeNodesOffset);
    return _AnalyzedScript.endAnalyzedScript(builder);
  }
  unpack() {
    return new AnalyzedScriptT(
      this.externalId(),
      this.databaseName(),
      this.schemaName(),
      this.bb.createObjList(this.tables.bind(this), this.tablesLength()),
      this.bb.createObjList(this.tableReferences.bind(this), this.tableReferencesLength()),
      this.bb.createObjList(this.columnReferences.bind(this), this.columnReferencesLength()),
      this.bb.createObjList(this.graphEdges.bind(this), this.graphEdgesLength()),
      this.bb.createObjList(this.graphEdgeNodes.bind(this), this.graphEdgeNodesLength())
    );
  }
  unpackTo(_o) {
    _o.externalId = this.externalId();
    _o.databaseName = this.databaseName();
    _o.schemaName = this.schemaName();
    _o.tables = this.bb.createObjList(this.tables.bind(this), this.tablesLength());
    _o.tableReferences = this.bb.createObjList(this.tableReferences.bind(this), this.tableReferencesLength());
    _o.columnReferences = this.bb.createObjList(this.columnReferences.bind(this), this.columnReferencesLength());
    _o.graphEdges = this.bb.createObjList(this.graphEdges.bind(this), this.graphEdgesLength());
    _o.graphEdgeNodes = this.bb.createObjList(this.graphEdgeNodes.bind(this), this.graphEdgeNodesLength());
  }
};
var AnalyzedScriptT = class {
  constructor(externalId = 0, databaseName = null, schemaName = null, tables = [], tableReferences = [], columnReferences = [], graphEdges = [], graphEdgeNodes = []) {
    this.externalId = externalId;
    this.databaseName = databaseName;
    this.schemaName = schemaName;
    this.tables = tables;
    this.tableReferences = tableReferences;
    this.columnReferences = columnReferences;
    this.graphEdges = graphEdges;
    this.graphEdgeNodes = graphEdgeNodes;
  }
  pack(builder) {
    const databaseName = this.databaseName !== null ? builder.createString(this.databaseName) : 0;
    const schemaName = this.schemaName !== null ? builder.createString(this.schemaName) : 0;
    const tables = AnalyzedScript.createTablesVector(builder, builder.createObjectOffsetList(this.tables));
    const tableReferences = AnalyzedScript.createTableReferencesVector(builder, builder.createObjectOffsetList(this.tableReferences));
    const columnReferences = AnalyzedScript.createColumnReferencesVector(builder, builder.createObjectOffsetList(this.columnReferences));
    const graphEdges = builder.createStructOffsetList(this.graphEdges, AnalyzedScript.startGraphEdgesVector);
    const graphEdgeNodes = builder.createStructOffsetList(this.graphEdgeNodes, AnalyzedScript.startGraphEdgeNodesVector);
    return AnalyzedScript.createAnalyzedScript(
      builder,
      this.externalId,
      databaseName,
      schemaName,
      tables,
      tableReferences,
      columnReferences,
      graphEdges,
      graphEdgeNodes
    );
  }
};

// gen/sqlynx/proto/attribute-key.ts
var AttributeKey = /* @__PURE__ */ ((AttributeKey2) => {
  AttributeKey2[AttributeKey2["NONE"] = 0] = "NONE";
  AttributeKey2[AttributeKey2["SQL_KEYS_"] = 1] = "SQL_KEYS_";
  AttributeKey2[AttributeKey2["SQL_ALIAS_COLUMN_DEFS"] = 2] = "SQL_ALIAS_COLUMN_DEFS";
  AttributeKey2[AttributeKey2["SQL_ALIAS_COLUMN_NAMES"] = 3] = "SQL_ALIAS_COLUMN_NAMES";
  AttributeKey2[AttributeKey2["SQL_ALIAS_NAME"] = 4] = "SQL_ALIAS_NAME";
  AttributeKey2[AttributeKey2["SQL_BIT_TYPE_LENGTH"] = 5] = "SQL_BIT_TYPE_LENGTH";
  AttributeKey2[AttributeKey2["SQL_BIT_TYPE_VARYING"] = 6] = "SQL_BIT_TYPE_VARYING";
  AttributeKey2[AttributeKey2["SQL_CASE_ARGUMENT"] = 7] = "SQL_CASE_ARGUMENT";
  AttributeKey2[AttributeKey2["SQL_CASE_CLAUSES"] = 8] = "SQL_CASE_CLAUSES";
  AttributeKey2[AttributeKey2["SQL_CASE_CLAUSE_THEN"] = 9] = "SQL_CASE_CLAUSE_THEN";
  AttributeKey2[AttributeKey2["SQL_CASE_CLAUSE_WHEN"] = 10] = "SQL_CASE_CLAUSE_WHEN";
  AttributeKey2[AttributeKey2["SQL_CASE_DEFAULT"] = 11] = "SQL_CASE_DEFAULT";
  AttributeKey2[AttributeKey2["SQL_CHARACTER_TYPE"] = 12] = "SQL_CHARACTER_TYPE";
  AttributeKey2[AttributeKey2["SQL_CHARACTER_TYPE_LENGTH"] = 13] = "SQL_CHARACTER_TYPE_LENGTH";
  AttributeKey2[AttributeKey2["SQL_COLUMN_CONSTRAINT_COLLATE"] = 14] = "SQL_COLUMN_CONSTRAINT_COLLATE";
  AttributeKey2[AttributeKey2["SQL_COLUMN_CONSTRAINT_DEFINITION"] = 15] = "SQL_COLUMN_CONSTRAINT_DEFINITION";
  AttributeKey2[AttributeKey2["SQL_COLUMN_CONSTRAINT_NAME"] = 16] = "SQL_COLUMN_CONSTRAINT_NAME";
  AttributeKey2[AttributeKey2["SQL_COLUMN_CONSTRAINT_NO_INHERIT"] = 17] = "SQL_COLUMN_CONSTRAINT_NO_INHERIT";
  AttributeKey2[AttributeKey2["SQL_COLUMN_CONSTRAINT_TYPE"] = 18] = "SQL_COLUMN_CONSTRAINT_TYPE";
  AttributeKey2[AttributeKey2["SQL_COLUMN_CONSTRAINT_VALUE"] = 19] = "SQL_COLUMN_CONSTRAINT_VALUE";
  AttributeKey2[AttributeKey2["SQL_COLUMN_DEF_COLLATE"] = 20] = "SQL_COLUMN_DEF_COLLATE";
  AttributeKey2[AttributeKey2["SQL_COLUMN_DEF_CONSTRAINTS"] = 21] = "SQL_COLUMN_DEF_CONSTRAINTS";
  AttributeKey2[AttributeKey2["SQL_COLUMN_DEF_NAME"] = 22] = "SQL_COLUMN_DEF_NAME";
  AttributeKey2[AttributeKey2["SQL_COLUMN_DEF_OPTIONS"] = 23] = "SQL_COLUMN_DEF_OPTIONS";
  AttributeKey2[AttributeKey2["SQL_COLUMN_DEF_TYPE"] = 24] = "SQL_COLUMN_DEF_TYPE";
  AttributeKey2[AttributeKey2["SQL_COLUMN_REF_PATH"] = 25] = "SQL_COLUMN_REF_PATH";
  AttributeKey2[AttributeKey2["SQL_COMBINE_INPUT"] = 26] = "SQL_COMBINE_INPUT";
  AttributeKey2[AttributeKey2["SQL_COMBINE_MODIFIER"] = 27] = "SQL_COMBINE_MODIFIER";
  AttributeKey2[AttributeKey2["SQL_COMBINE_OPERATION"] = 28] = "SQL_COMBINE_OPERATION";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_FUNC_ARGS_LIST"] = 29] = "SQL_CONST_CAST_FUNC_ARGS_LIST";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_FUNC_ARGS_ORDER"] = 30] = "SQL_CONST_CAST_FUNC_ARGS_ORDER";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_FUNC_NAME"] = 31] = "SQL_CONST_CAST_FUNC_NAME";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_INTERVAL"] = 32] = "SQL_CONST_CAST_INTERVAL";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_INTERVAL_PRECISION"] = 33] = "SQL_CONST_CAST_INTERVAL_PRECISION";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_TYPE"] = 34] = "SQL_CONST_CAST_TYPE";
  AttributeKey2[AttributeKey2["SQL_CONST_CAST_VALUE"] = 35] = "SQL_CONST_CAST_VALUE";
  AttributeKey2[AttributeKey2["SQL_CONST_TYPE"] = 36] = "SQL_CONST_TYPE";
  AttributeKey2[AttributeKey2["SQL_CONST_VALUE"] = 37] = "SQL_CONST_VALUE";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_COLUMNS"] = 38] = "SQL_CREATE_AS_COLUMNS";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_IF_NOT_EXISTS"] = 39] = "SQL_CREATE_AS_IF_NOT_EXISTS";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_NAME"] = 40] = "SQL_CREATE_AS_NAME";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_ON_COMMIT"] = 41] = "SQL_CREATE_AS_ON_COMMIT";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_STATEMENT"] = 42] = "SQL_CREATE_AS_STATEMENT";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_TEMP"] = 43] = "SQL_CREATE_AS_TEMP";
  AttributeKey2[AttributeKey2["SQL_CREATE_AS_WITH_DATA"] = 44] = "SQL_CREATE_AS_WITH_DATA";
  AttributeKey2[AttributeKey2["SQL_CREATE_TABLE_ELEMENTS"] = 45] = "SQL_CREATE_TABLE_ELEMENTS";
  AttributeKey2[AttributeKey2["SQL_CREATE_TABLE_IF_NOT_EXISTS"] = 46] = "SQL_CREATE_TABLE_IF_NOT_EXISTS";
  AttributeKey2[AttributeKey2["SQL_CREATE_TABLE_NAME"] = 47] = "SQL_CREATE_TABLE_NAME";
  AttributeKey2[AttributeKey2["SQL_CREATE_TABLE_ON_COMMIT"] = 48] = "SQL_CREATE_TABLE_ON_COMMIT";
  AttributeKey2[AttributeKey2["SQL_CREATE_TABLE_TEMP"] = 49] = "SQL_CREATE_TABLE_TEMP";
  AttributeKey2[AttributeKey2["SQL_CTE_COLUMNS"] = 50] = "SQL_CTE_COLUMNS";
  AttributeKey2[AttributeKey2["SQL_CTE_NAME"] = 51] = "SQL_CTE_NAME";
  AttributeKey2[AttributeKey2["SQL_CTE_STATEMENT"] = 52] = "SQL_CTE_STATEMENT";
  AttributeKey2[AttributeKey2["SQL_DEFINITION_ARG_KEY"] = 53] = "SQL_DEFINITION_ARG_KEY";
  AttributeKey2[AttributeKey2["SQL_DEFINITION_ARG_VALUE"] = 54] = "SQL_DEFINITION_ARG_VALUE";
  AttributeKey2[AttributeKey2["SQL_EXISTS_EXPRESSION_STATEMENT"] = 55] = "SQL_EXISTS_EXPRESSION_STATEMENT";
  AttributeKey2[AttributeKey2["SQL_EXPRESSION_ARGS"] = 56] = "SQL_EXPRESSION_ARGS";
  AttributeKey2[AttributeKey2["SQL_EXPRESSION_OPERATOR"] = 57] = "SQL_EXPRESSION_OPERATOR";
  AttributeKey2[AttributeKey2["SQL_EXPRESSION_POSTFIX"] = 58] = "SQL_EXPRESSION_POSTFIX";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_ALL"] = 59] = "SQL_FUNCTION_ALL";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_ARGUMENTS"] = 60] = "SQL_FUNCTION_ARGUMENTS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_ARG_NAME"] = 61] = "SQL_FUNCTION_ARG_NAME";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_ARG_VALUE"] = 62] = "SQL_FUNCTION_ARG_VALUE";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_CAST_ARGS"] = 63] = "SQL_FUNCTION_CAST_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_CAST_TYPE"] = 64] = "SQL_FUNCTION_CAST_TYPE";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_CAST_VALUE"] = 65] = "SQL_FUNCTION_CAST_VALUE";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_DISTINCT"] = 66] = "SQL_FUNCTION_DISTINCT";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_EXTRACT_ARGS"] = 67] = "SQL_FUNCTION_EXTRACT_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_EXTRACT_INPUT"] = 68] = "SQL_FUNCTION_EXTRACT_INPUT";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_EXTRACT_TARGET"] = 69] = "SQL_FUNCTION_EXTRACT_TARGET";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_FILTER"] = 70] = "SQL_FUNCTION_FILTER";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_NAME"] = 71] = "SQL_FUNCTION_NAME";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_ORDER"] = 72] = "SQL_FUNCTION_ORDER";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_OVER"] = 73] = "SQL_FUNCTION_OVER";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_OVERLAY_ARGS"] = 74] = "SQL_FUNCTION_OVERLAY_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_OVERLAY_FOR"] = 75] = "SQL_FUNCTION_OVERLAY_FOR";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_OVERLAY_FROM"] = 76] = "SQL_FUNCTION_OVERLAY_FROM";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_OVERLAY_INPUT"] = 77] = "SQL_FUNCTION_OVERLAY_INPUT";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_OVERLAY_PLACING"] = 78] = "SQL_FUNCTION_OVERLAY_PLACING";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_POSITION_ARGS"] = 79] = "SQL_FUNCTION_POSITION_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_POSITION_INPUT"] = 80] = "SQL_FUNCTION_POSITION_INPUT";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_POSITION_SEARCH"] = 81] = "SQL_FUNCTION_POSITION_SEARCH";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_SUBSTRING_ARGS"] = 82] = "SQL_FUNCTION_SUBSTRING_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_SUBSTRING_FOR"] = 83] = "SQL_FUNCTION_SUBSTRING_FOR";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_SUBSTRING_FROM"] = 84] = "SQL_FUNCTION_SUBSTRING_FROM";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_SUBSTRING_INPUT"] = 85] = "SQL_FUNCTION_SUBSTRING_INPUT";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TABLE_FUNCTION"] = 86] = "SQL_FUNCTION_TABLE_FUNCTION";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TABLE_ROWS_FROM"] = 87] = "SQL_FUNCTION_TABLE_ROWS_FROM";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TABLE_WITH_ORDINALITY"] = 88] = "SQL_FUNCTION_TABLE_WITH_ORDINALITY";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TREAT_ARGS"] = 89] = "SQL_FUNCTION_TREAT_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TREAT_TYPE"] = 90] = "SQL_FUNCTION_TREAT_TYPE";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TREAT_VALUE"] = 91] = "SQL_FUNCTION_TREAT_VALUE";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TRIM_ARGS"] = 92] = "SQL_FUNCTION_TRIM_ARGS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TRIM_CHARACTERS"] = 93] = "SQL_FUNCTION_TRIM_CHARACTERS";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TRIM_DIRECTION"] = 94] = "SQL_FUNCTION_TRIM_DIRECTION";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_TRIM_INPUT"] = 95] = "SQL_FUNCTION_TRIM_INPUT";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_VARIADIC"] = 96] = "SQL_FUNCTION_VARIADIC";
  AttributeKey2[AttributeKey2["SQL_FUNCTION_WITHIN_GROUP"] = 97] = "SQL_FUNCTION_WITHIN_GROUP";
  AttributeKey2[AttributeKey2["SQL_GENERIC_OPTION_KEY"] = 98] = "SQL_GENERIC_OPTION_KEY";
  AttributeKey2[AttributeKey2["SQL_GENERIC_OPTION_VALUE"] = 99] = "SQL_GENERIC_OPTION_VALUE";
  AttributeKey2[AttributeKey2["SQL_GENERIC_TYPE_MODIFIERS"] = 100] = "SQL_GENERIC_TYPE_MODIFIERS";
  AttributeKey2[AttributeKey2["SQL_GENERIC_TYPE_NAME"] = 101] = "SQL_GENERIC_TYPE_NAME";
  AttributeKey2[AttributeKey2["SQL_GROUP_BY_ITEM_ARG"] = 102] = "SQL_GROUP_BY_ITEM_ARG";
  AttributeKey2[AttributeKey2["SQL_GROUP_BY_ITEM_ARGS"] = 103] = "SQL_GROUP_BY_ITEM_ARGS";
  AttributeKey2[AttributeKey2["SQL_GROUP_BY_ITEM_TYPE"] = 104] = "SQL_GROUP_BY_ITEM_TYPE";
  AttributeKey2[AttributeKey2["SQL_INDIRECTION_INDEX_LOWER_BOUND"] = 105] = "SQL_INDIRECTION_INDEX_LOWER_BOUND";
  AttributeKey2[AttributeKey2["SQL_INDIRECTION_INDEX_UPPER_BOUND"] = 106] = "SQL_INDIRECTION_INDEX_UPPER_BOUND";
  AttributeKey2[AttributeKey2["SQL_INDIRECTION_INDEX_VALUE"] = 107] = "SQL_INDIRECTION_INDEX_VALUE";
  AttributeKey2[AttributeKey2["SQL_INDIRECTION_PATH"] = 108] = "SQL_INDIRECTION_PATH";
  AttributeKey2[AttributeKey2["SQL_INDIRECTION_VALUE"] = 109] = "SQL_INDIRECTION_VALUE";
  AttributeKey2[AttributeKey2["SQL_INTERVAL_PRECISION"] = 110] = "SQL_INTERVAL_PRECISION";
  AttributeKey2[AttributeKey2["SQL_INTERVAL_TYPE"] = 111] = "SQL_INTERVAL_TYPE";
  AttributeKey2[AttributeKey2["SQL_JOIN_INPUT"] = 112] = "SQL_JOIN_INPUT";
  AttributeKey2[AttributeKey2["SQL_JOIN_ON"] = 113] = "SQL_JOIN_ON";
  AttributeKey2[AttributeKey2["SQL_JOIN_TYPE"] = 114] = "SQL_JOIN_TYPE";
  AttributeKey2[AttributeKey2["SQL_JOIN_USING"] = 115] = "SQL_JOIN_USING";
  AttributeKey2[AttributeKey2["SQL_KEY_ACTION_COMMAND"] = 116] = "SQL_KEY_ACTION_COMMAND";
  AttributeKey2[AttributeKey2["SQL_KEY_ACTION_TRIGGER"] = 117] = "SQL_KEY_ACTION_TRIGGER";
  AttributeKey2[AttributeKey2["SQL_NUMERIC_TYPE_BASE"] = 118] = "SQL_NUMERIC_TYPE_BASE";
  AttributeKey2[AttributeKey2["SQL_NUMERIC_TYPE_MODIFIERS"] = 119] = "SQL_NUMERIC_TYPE_MODIFIERS";
  AttributeKey2[AttributeKey2["SQL_ORDER_DIRECTION"] = 120] = "SQL_ORDER_DIRECTION";
  AttributeKey2[AttributeKey2["SQL_ORDER_NULLRULE"] = 121] = "SQL_ORDER_NULLRULE";
  AttributeKey2[AttributeKey2["SQL_ORDER_VALUE"] = 122] = "SQL_ORDER_VALUE";
  AttributeKey2[AttributeKey2["SQL_PARAMETER_NAME"] = 123] = "SQL_PARAMETER_NAME";
  AttributeKey2[AttributeKey2["SQL_QUALIFIED_NAME_CATALOG"] = 124] = "SQL_QUALIFIED_NAME_CATALOG";
  AttributeKey2[AttributeKey2["SQL_QUALIFIED_NAME_INDEX"] = 125] = "SQL_QUALIFIED_NAME_INDEX";
  AttributeKey2[AttributeKey2["SQL_QUALIFIED_NAME_RELATION"] = 126] = "SQL_QUALIFIED_NAME_RELATION";
  AttributeKey2[AttributeKey2["SQL_QUALIFIED_NAME_SCHEMA"] = 127] = "SQL_QUALIFIED_NAME_SCHEMA";
  AttributeKey2[AttributeKey2["SQL_RESULT_TARGET_NAME"] = 128] = "SQL_RESULT_TARGET_NAME";
  AttributeKey2[AttributeKey2["SQL_RESULT_TARGET_STAR"] = 129] = "SQL_RESULT_TARGET_STAR";
  AttributeKey2[AttributeKey2["SQL_RESULT_TARGET_VALUE"] = 130] = "SQL_RESULT_TARGET_VALUE";
  AttributeKey2[AttributeKey2["SQL_ROWSFROM_ITEM_COLUMNS"] = 131] = "SQL_ROWSFROM_ITEM_COLUMNS";
  AttributeKey2[AttributeKey2["SQL_ROWSFROM_ITEM_FUNCTION"] = 132] = "SQL_ROWSFROM_ITEM_FUNCTION";
  AttributeKey2[AttributeKey2["SQL_ROW_LOCKING"] = 133] = "SQL_ROW_LOCKING";
  AttributeKey2[AttributeKey2["SQL_ROW_LOCKING_BLOCK_BEHAVIOR"] = 134] = "SQL_ROW_LOCKING_BLOCK_BEHAVIOR";
  AttributeKey2[AttributeKey2["SQL_ROW_LOCKING_OF"] = 135] = "SQL_ROW_LOCKING_OF";
  AttributeKey2[AttributeKey2["SQL_ROW_LOCKING_STRENGTH"] = 136] = "SQL_ROW_LOCKING_STRENGTH";
  AttributeKey2[AttributeKey2["SQL_SAMPLE_COUNT_UNIT"] = 137] = "SQL_SAMPLE_COUNT_UNIT";
  AttributeKey2[AttributeKey2["SQL_SAMPLE_COUNT_VALUE"] = 138] = "SQL_SAMPLE_COUNT_VALUE";
  AttributeKey2[AttributeKey2["SQL_SAMPLE_FUNCTION"] = 139] = "SQL_SAMPLE_FUNCTION";
  AttributeKey2[AttributeKey2["SQL_SAMPLE_REPEAT"] = 140] = "SQL_SAMPLE_REPEAT";
  AttributeKey2[AttributeKey2["SQL_SAMPLE_SEED"] = 141] = "SQL_SAMPLE_SEED";
  AttributeKey2[AttributeKey2["SQL_SELECT_ALL"] = 142] = "SQL_SELECT_ALL";
  AttributeKey2[AttributeKey2["SQL_SELECT_DISTINCT"] = 143] = "SQL_SELECT_DISTINCT";
  AttributeKey2[AttributeKey2["SQL_SELECT_EXPRESSION_INDIRECTION"] = 144] = "SQL_SELECT_EXPRESSION_INDIRECTION";
  AttributeKey2[AttributeKey2["SQL_SELECT_EXPRESSION_STATEMENT"] = 145] = "SQL_SELECT_EXPRESSION_STATEMENT";
  AttributeKey2[AttributeKey2["SQL_SELECT_FROM"] = 146] = "SQL_SELECT_FROM";
  AttributeKey2[AttributeKey2["SQL_SELECT_GROUPS"] = 147] = "SQL_SELECT_GROUPS";
  AttributeKey2[AttributeKey2["SQL_SELECT_HAVING"] = 148] = "SQL_SELECT_HAVING";
  AttributeKey2[AttributeKey2["SQL_SELECT_INTO"] = 149] = "SQL_SELECT_INTO";
  AttributeKey2[AttributeKey2["SQL_SELECT_LIMIT"] = 150] = "SQL_SELECT_LIMIT";
  AttributeKey2[AttributeKey2["SQL_SELECT_LIMIT_ALL"] = 151] = "SQL_SELECT_LIMIT_ALL";
  AttributeKey2[AttributeKey2["SQL_SELECT_OFFSET"] = 152] = "SQL_SELECT_OFFSET";
  AttributeKey2[AttributeKey2["SQL_SELECT_ORDER"] = 153] = "SQL_SELECT_ORDER";
  AttributeKey2[AttributeKey2["SQL_SELECT_ROW_LOCKING"] = 154] = "SQL_SELECT_ROW_LOCKING";
  AttributeKey2[AttributeKey2["SQL_SELECT_SAMPLE"] = 155] = "SQL_SELECT_SAMPLE";
  AttributeKey2[AttributeKey2["SQL_SELECT_TABLE"] = 156] = "SQL_SELECT_TABLE";
  AttributeKey2[AttributeKey2["SQL_SELECT_TARGETS"] = 157] = "SQL_SELECT_TARGETS";
  AttributeKey2[AttributeKey2["SQL_SELECT_VALUES"] = 158] = "SQL_SELECT_VALUES";
  AttributeKey2[AttributeKey2["SQL_SELECT_WHERE"] = 159] = "SQL_SELECT_WHERE";
  AttributeKey2[AttributeKey2["SQL_SELECT_WINDOWS"] = 160] = "SQL_SELECT_WINDOWS";
  AttributeKey2[AttributeKey2["SQL_SELECT_WITH_CTES"] = 161] = "SQL_SELECT_WITH_CTES";
  AttributeKey2[AttributeKey2["SQL_SELECT_WITH_RECURSIVE"] = 162] = "SQL_SELECT_WITH_RECURSIVE";
  AttributeKey2[AttributeKey2["SQL_SUBQUERY_ARG0"] = 163] = "SQL_SUBQUERY_ARG0";
  AttributeKey2[AttributeKey2["SQL_SUBQUERY_ARG1"] = 164] = "SQL_SUBQUERY_ARG1";
  AttributeKey2[AttributeKey2["SQL_SUBQUERY_OPERATOR"] = 165] = "SQL_SUBQUERY_OPERATOR";
  AttributeKey2[AttributeKey2["SQL_SUBQUERY_QUANTIFIER"] = 166] = "SQL_SUBQUERY_QUANTIFIER";
  AttributeKey2[AttributeKey2["SQL_TABLEREF_ALIAS"] = 167] = "SQL_TABLEREF_ALIAS";
  AttributeKey2[AttributeKey2["SQL_TABLEREF_LATERAL"] = 168] = "SQL_TABLEREF_LATERAL";
  AttributeKey2[AttributeKey2["SQL_TABLEREF_ONLY"] = 169] = "SQL_TABLEREF_ONLY";
  AttributeKey2[AttributeKey2["SQL_TABLEREF_NAME"] = 170] = "SQL_TABLEREF_NAME";
  AttributeKey2[AttributeKey2["SQL_TABLEREF_SAMPLE"] = 171] = "SQL_TABLEREF_SAMPLE";
  AttributeKey2[AttributeKey2["SQL_TABLEREF_TABLE"] = 172] = "SQL_TABLEREF_TABLE";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_ARGUMENT"] = 173] = "SQL_TABLE_CONSTRAINT_ARGUMENT";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_ATTRIBUTES"] = 174] = "SQL_TABLE_CONSTRAINT_ATTRIBUTES";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_COLUMNS"] = 175] = "SQL_TABLE_CONSTRAINT_COLUMNS";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_DEFINITION"] = 176] = "SQL_TABLE_CONSTRAINT_DEFINITION";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_INDEX"] = 177] = "SQL_TABLE_CONSTRAINT_INDEX";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_KEY_ACTIONS"] = 178] = "SQL_TABLE_CONSTRAINT_KEY_ACTIONS";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_KEY_MATCH"] = 179] = "SQL_TABLE_CONSTRAINT_KEY_MATCH";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_NAME"] = 180] = "SQL_TABLE_CONSTRAINT_NAME";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_REFERENCES_COLUMNS"] = 181] = "SQL_TABLE_CONSTRAINT_REFERENCES_COLUMNS";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_REFERENCES_NAME"] = 182] = "SQL_TABLE_CONSTRAINT_REFERENCES_NAME";
  AttributeKey2[AttributeKey2["SQL_TABLE_CONSTRAINT_TYPE"] = 183] = "SQL_TABLE_CONSTRAINT_TYPE";
  AttributeKey2[AttributeKey2["SQL_TEMP_NAME"] = 184] = "SQL_TEMP_NAME";
  AttributeKey2[AttributeKey2["SQL_TEMP_TYPE"] = 185] = "SQL_TEMP_TYPE";
  AttributeKey2[AttributeKey2["SQL_TIME_TYPE_PRECISION"] = 186] = "SQL_TIME_TYPE_PRECISION";
  AttributeKey2[AttributeKey2["SQL_TIME_TYPE_WITH_TIMEZONE"] = 187] = "SQL_TIME_TYPE_WITH_TIMEZONE";
  AttributeKey2[AttributeKey2["SQL_TYPENAME_ARRAY"] = 188] = "SQL_TYPENAME_ARRAY";
  AttributeKey2[AttributeKey2["SQL_TYPENAME_SETOF"] = 189] = "SQL_TYPENAME_SETOF";
  AttributeKey2[AttributeKey2["SQL_TYPENAME_TYPE"] = 190] = "SQL_TYPENAME_TYPE";
  AttributeKey2[AttributeKey2["SQL_TYPECAST_TYPE"] = 191] = "SQL_TYPECAST_TYPE";
  AttributeKey2[AttributeKey2["SQL_TYPECAST_VALUE"] = 192] = "SQL_TYPECAST_VALUE";
  AttributeKey2[AttributeKey2["SQL_TYPETEST_NEGATE"] = 193] = "SQL_TYPETEST_NEGATE";
  AttributeKey2[AttributeKey2["SQL_TYPETEST_TYPES"] = 194] = "SQL_TYPETEST_TYPES";
  AttributeKey2[AttributeKey2["SQL_TYPETEST_VALUE"] = 195] = "SQL_TYPETEST_VALUE";
  AttributeKey2[AttributeKey2["SQL_VIEW_COLUMNS"] = 196] = "SQL_VIEW_COLUMNS";
  AttributeKey2[AttributeKey2["SQL_VIEW_NAME"] = 197] = "SQL_VIEW_NAME";
  AttributeKey2[AttributeKey2["SQL_VIEW_STATEMENT"] = 198] = "SQL_VIEW_STATEMENT";
  AttributeKey2[AttributeKey2["SQL_VIEW_TEMP"] = 199] = "SQL_VIEW_TEMP";
  AttributeKey2[AttributeKey2["SQL_WINDOW_BOUND_DIRECTION"] = 200] = "SQL_WINDOW_BOUND_DIRECTION";
  AttributeKey2[AttributeKey2["SQL_WINDOW_BOUND_MODE"] = 201] = "SQL_WINDOW_BOUND_MODE";
  AttributeKey2[AttributeKey2["SQL_WINDOW_BOUND_VALUE"] = 202] = "SQL_WINDOW_BOUND_VALUE";
  AttributeKey2[AttributeKey2["SQL_WINDOW_DEF_FRAME"] = 203] = "SQL_WINDOW_DEF_FRAME";
  AttributeKey2[AttributeKey2["SQL_WINDOW_DEF_NAME"] = 204] = "SQL_WINDOW_DEF_NAME";
  AttributeKey2[AttributeKey2["SQL_WINDOW_FRAME_BOUNDS"] = 205] = "SQL_WINDOW_FRAME_BOUNDS";
  AttributeKey2[AttributeKey2["SQL_WINDOW_FRAME_EXCLUDE"] = 206] = "SQL_WINDOW_FRAME_EXCLUDE";
  AttributeKey2[AttributeKey2["SQL_WINDOW_FRAME_MODE"] = 207] = "SQL_WINDOW_FRAME_MODE";
  AttributeKey2[AttributeKey2["SQL_WINDOW_FRAME_NAME"] = 208] = "SQL_WINDOW_FRAME_NAME";
  AttributeKey2[AttributeKey2["SQL_WINDOW_FRAME_ORDER"] = 209] = "SQL_WINDOW_FRAME_ORDER";
  AttributeKey2[AttributeKey2["SQL_WINDOW_FRAME_PARTITION"] = 210] = "SQL_WINDOW_FRAME_PARTITION";
  AttributeKey2[AttributeKey2["EXT_SET_VARARGS"] = 211] = "EXT_SET_VARARGS";
  AttributeKey2[AttributeKey2["EXT_VARARG_ARRAY_VALUES"] = 212] = "EXT_VARARG_ARRAY_VALUES";
  AttributeKey2[AttributeKey2["EXT_VARARG_FIELD_KEY"] = 213] = "EXT_VARARG_FIELD_KEY";
  AttributeKey2[AttributeKey2["EXT_VARARG_FIELD_VALUE"] = 214] = "EXT_VARARG_FIELD_VALUE";
  return AttributeKey2;
})(AttributeKey || {});

// gen/sqlynx/proto/catalog-entries.ts
import * as flatbuffers12 from "flatbuffers";

// gen/sqlynx/proto/catalog-entry.ts
import * as flatbuffers11 from "flatbuffers";

// gen/sqlynx/proto/catalog-entry-type.ts
var CatalogEntryType = /* @__PURE__ */ ((CatalogEntryType2) => {
  CatalogEntryType2[CatalogEntryType2["SCRIPT"] = 0] = "SCRIPT";
  CatalogEntryType2[CatalogEntryType2["DESCRIPTOR_POOL"] = 1] = "DESCRIPTOR_POOL";
  return CatalogEntryType2;
})(CatalogEntryType || {});

// gen/sqlynx/proto/schema-descriptor.ts
import * as flatbuffers10 from "flatbuffers";

// gen/sqlynx/proto/schema-table.ts
import * as flatbuffers9 from "flatbuffers";

// gen/sqlynx/proto/schema-table-column.ts
import * as flatbuffers8 from "flatbuffers";
var SchemaTableColumn = class _SchemaTableColumn {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsSchemaTableColumn(bb, obj) {
    return (obj || new _SchemaTableColumn()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsSchemaTableColumn(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers8.SIZE_PREFIX_LENGTH);
    return (obj || new _SchemaTableColumn()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  columnName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.SchemaTableColumn";
  }
  static startSchemaTableColumn(builder) {
    builder.startObject(1);
  }
  static addColumnName(builder, columnNameOffset) {
    builder.addFieldOffset(0, columnNameOffset, 0);
  }
  static endSchemaTableColumn(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createSchemaTableColumn(builder, columnNameOffset) {
    _SchemaTableColumn.startSchemaTableColumn(builder);
    _SchemaTableColumn.addColumnName(builder, columnNameOffset);
    return _SchemaTableColumn.endSchemaTableColumn(builder);
  }
  unpack() {
    return new SchemaTableColumnT(
      this.columnName()
    );
  }
  unpackTo(_o) {
    _o.columnName = this.columnName();
  }
};
var SchemaTableColumnT = class {
  constructor(columnName = null) {
    this.columnName = columnName;
  }
  pack(builder) {
    const columnName = this.columnName !== null ? builder.createString(this.columnName) : 0;
    return SchemaTableColumn.createSchemaTableColumn(
      builder,
      columnName
    );
  }
};

// gen/sqlynx/proto/schema-table.ts
var SchemaTable = class _SchemaTable {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsSchemaTable(bb, obj) {
    return (obj || new _SchemaTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsSchemaTable(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers9.SIZE_PREFIX_LENGTH);
    return (obj || new _SchemaTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  tableId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_table_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  tableName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  columns(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new SchemaTableColumn()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  columnsLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.SchemaTable";
  }
  static startSchemaTable(builder) {
    builder.startObject(3);
  }
  static addTableId(builder, tableId) {
    builder.addFieldInt32(0, tableId, 0);
  }
  static addTableName(builder, tableNameOffset) {
    builder.addFieldOffset(1, tableNameOffset, 0);
  }
  static addColumns(builder, columnsOffset) {
    builder.addFieldOffset(2, columnsOffset, 0);
  }
  static createColumnsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startColumnsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endSchemaTable(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createSchemaTable(builder, tableId, tableNameOffset, columnsOffset) {
    _SchemaTable.startSchemaTable(builder);
    _SchemaTable.addTableId(builder, tableId);
    _SchemaTable.addTableName(builder, tableNameOffset);
    _SchemaTable.addColumns(builder, columnsOffset);
    return _SchemaTable.endSchemaTable(builder);
  }
  unpack() {
    return new SchemaTableT(
      this.tableId(),
      this.tableName(),
      this.bb.createObjList(this.columns.bind(this), this.columnsLength())
    );
  }
  unpackTo(_o) {
    _o.tableId = this.tableId();
    _o.tableName = this.tableName();
    _o.columns = this.bb.createObjList(this.columns.bind(this), this.columnsLength());
  }
};
var SchemaTableT = class {
  constructor(tableId = 0, tableName = null, columns = []) {
    this.tableId = tableId;
    this.tableName = tableName;
    this.columns = columns;
  }
  pack(builder) {
    const tableName = this.tableName !== null ? builder.createString(this.tableName) : 0;
    const columns = SchemaTable.createColumnsVector(builder, builder.createObjectOffsetList(this.columns));
    return SchemaTable.createSchemaTable(
      builder,
      this.tableId,
      tableName,
      columns
    );
  }
};

// gen/sqlynx/proto/schema-descriptor.ts
var SchemaDescriptor = class _SchemaDescriptor {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsSchemaDescriptor(bb, obj) {
    return (obj || new _SchemaDescriptor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsSchemaDescriptor(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers10.SIZE_PREFIX_LENGTH);
    return (obj || new _SchemaDescriptor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  databaseName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  schemaName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  tables(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new SchemaTable()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  tablesLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.SchemaDescriptor";
  }
  static startSchemaDescriptor(builder) {
    builder.startObject(3);
  }
  static addDatabaseName(builder, databaseNameOffset) {
    builder.addFieldOffset(0, databaseNameOffset, 0);
  }
  static addSchemaName(builder, schemaNameOffset) {
    builder.addFieldOffset(1, schemaNameOffset, 0);
  }
  static addTables(builder, tablesOffset) {
    builder.addFieldOffset(2, tablesOffset, 0);
  }
  static createTablesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startTablesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endSchemaDescriptor(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createSchemaDescriptor(builder, databaseNameOffset, schemaNameOffset, tablesOffset) {
    _SchemaDescriptor.startSchemaDescriptor(builder);
    _SchemaDescriptor.addDatabaseName(builder, databaseNameOffset);
    _SchemaDescriptor.addSchemaName(builder, schemaNameOffset);
    _SchemaDescriptor.addTables(builder, tablesOffset);
    return _SchemaDescriptor.endSchemaDescriptor(builder);
  }
  unpack() {
    return new SchemaDescriptorT(
      this.databaseName(),
      this.schemaName(),
      this.bb.createObjList(this.tables.bind(this), this.tablesLength())
    );
  }
  unpackTo(_o) {
    _o.databaseName = this.databaseName();
    _o.schemaName = this.schemaName();
    _o.tables = this.bb.createObjList(this.tables.bind(this), this.tablesLength());
  }
};
var SchemaDescriptorT = class {
  constructor(databaseName = null, schemaName = null, tables = []) {
    this.databaseName = databaseName;
    this.schemaName = schemaName;
    this.tables = tables;
  }
  pack(builder) {
    const databaseName = this.databaseName !== null ? builder.createString(this.databaseName) : 0;
    const schemaName = this.schemaName !== null ? builder.createString(this.schemaName) : 0;
    const tables = SchemaDescriptor.createTablesVector(builder, builder.createObjectOffsetList(this.tables));
    return SchemaDescriptor.createSchemaDescriptor(
      builder,
      databaseName,
      schemaName,
      tables
    );
  }
};

// gen/sqlynx/proto/catalog-entry.ts
var CatalogEntry = class _CatalogEntry {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsCatalogEntry(bb, obj) {
    return (obj || new _CatalogEntry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsCatalogEntry(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers11.SIZE_PREFIX_LENGTH);
    return (obj || new _CatalogEntry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  externalId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_external_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  entryType() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0 /* SCRIPT */;
  }
  mutate_entry_type(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint8(this.bb_pos + offset, value);
    return true;
  }
  rank() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_rank(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  schemas(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new SchemaDescriptor()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  schemasLength() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.CatalogEntry";
  }
  static startCatalogEntry(builder) {
    builder.startObject(4);
  }
  static addExternalId(builder, externalId) {
    builder.addFieldInt32(0, externalId, 0);
  }
  static addEntryType(builder, entryType) {
    builder.addFieldInt8(1, entryType, 0 /* SCRIPT */);
  }
  static addRank(builder, rank) {
    builder.addFieldInt32(2, rank, 0);
  }
  static addSchemas(builder, schemasOffset) {
    builder.addFieldOffset(3, schemasOffset, 0);
  }
  static createSchemasVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startSchemasVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endCatalogEntry(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createCatalogEntry(builder, externalId, entryType, rank, schemasOffset) {
    _CatalogEntry.startCatalogEntry(builder);
    _CatalogEntry.addExternalId(builder, externalId);
    _CatalogEntry.addEntryType(builder, entryType);
    _CatalogEntry.addRank(builder, rank);
    _CatalogEntry.addSchemas(builder, schemasOffset);
    return _CatalogEntry.endCatalogEntry(builder);
  }
  unpack() {
    return new CatalogEntryT(
      this.externalId(),
      this.entryType(),
      this.rank(),
      this.bb.createObjList(this.schemas.bind(this), this.schemasLength())
    );
  }
  unpackTo(_o) {
    _o.externalId = this.externalId();
    _o.entryType = this.entryType();
    _o.rank = this.rank();
    _o.schemas = this.bb.createObjList(this.schemas.bind(this), this.schemasLength());
  }
};
var CatalogEntryT = class {
  constructor(externalId = 0, entryType = 0 /* SCRIPT */, rank = 0, schemas = []) {
    this.externalId = externalId;
    this.entryType = entryType;
    this.rank = rank;
    this.schemas = schemas;
  }
  pack(builder) {
    const schemas = CatalogEntry.createSchemasVector(builder, builder.createObjectOffsetList(this.schemas));
    return CatalogEntry.createCatalogEntry(
      builder,
      this.externalId,
      this.entryType,
      this.rank,
      schemas
    );
  }
};

// gen/sqlynx/proto/catalog-entries.ts
var CatalogEntries = class _CatalogEntries {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsCatalogEntries(bb, obj) {
    return (obj || new _CatalogEntries()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsCatalogEntries(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers12.SIZE_PREFIX_LENGTH);
    return (obj || new _CatalogEntries()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  entries(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? (obj || new CatalogEntry()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  entriesLength() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.CatalogEntries";
  }
  static startCatalogEntries(builder) {
    builder.startObject(1);
  }
  static addEntries(builder, entriesOffset) {
    builder.addFieldOffset(0, entriesOffset, 0);
  }
  static createEntriesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startEntriesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endCatalogEntries(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createCatalogEntries(builder, entriesOffset) {
    _CatalogEntries.startCatalogEntries(builder);
    _CatalogEntries.addEntries(builder, entriesOffset);
    return _CatalogEntries.endCatalogEntries(builder);
  }
  unpack() {
    return new CatalogEntriesT(
      this.bb.createObjList(this.entries.bind(this), this.entriesLength())
    );
  }
  unpackTo(_o) {
    _o.entries = this.bb.createObjList(this.entries.bind(this), this.entriesLength());
  }
};
var CatalogEntriesT = class {
  constructor(entries = []) {
    this.entries = entries;
  }
  pack(builder) {
    const entries = CatalogEntries.createEntriesVector(builder, builder.createObjectOffsetList(this.entries));
    return CatalogEntries.createCatalogEntries(
      builder,
      entries
    );
  }
};

// gen/sqlynx/proto/character-type.ts
var CharacterType = /* @__PURE__ */ ((CharacterType2) => {
  CharacterType2[CharacterType2["VARCHAR"] = 0] = "VARCHAR";
  CharacterType2[CharacterType2["BLANK_PADDED_CHAR"] = 1] = "BLANK_PADDED_CHAR";
  return CharacterType2;
})(CharacterType || {});

// gen/sqlynx/proto/column-constraint.ts
var ColumnConstraint = /* @__PURE__ */ ((ColumnConstraint2) => {
  ColumnConstraint2[ColumnConstraint2["NOT_NULL"] = 0] = "NOT_NULL";
  ColumnConstraint2[ColumnConstraint2["NULL_"] = 1] = "NULL_";
  ColumnConstraint2[ColumnConstraint2["UNIQUE"] = 2] = "UNIQUE";
  ColumnConstraint2[ColumnConstraint2["PRIMARY_KEY"] = 3] = "PRIMARY_KEY";
  ColumnConstraint2[ColumnConstraint2["CHECK"] = 4] = "CHECK";
  ColumnConstraint2[ColumnConstraint2["DEFAULT"] = 5] = "DEFAULT";
  ColumnConstraint2[ColumnConstraint2["COLLATE"] = 6] = "COLLATE";
  return ColumnConstraint2;
})(ColumnConstraint || {});

// gen/sqlynx/proto/combine-modifier.ts
var CombineModifier = /* @__PURE__ */ ((CombineModifier2) => {
  CombineModifier2[CombineModifier2["NONE"] = 0] = "NONE";
  CombineModifier2[CombineModifier2["ALL"] = 1] = "ALL";
  CombineModifier2[CombineModifier2["DISTINCT"] = 2] = "DISTINCT";
  return CombineModifier2;
})(CombineModifier || {});

// gen/sqlynx/proto/combine-operation.ts
var CombineOperation = /* @__PURE__ */ ((CombineOperation2) => {
  CombineOperation2[CombineOperation2["NONE"] = 0] = "NONE";
  CombineOperation2[CombineOperation2["INTERSECT"] = 1] = "INTERSECT";
  CombineOperation2[CombineOperation2["UNION"] = 2] = "UNION";
  CombineOperation2[CombineOperation2["EXCEPT"] = 3] = "EXCEPT";
  return CombineOperation2;
})(CombineOperation || {});

// gen/sqlynx/proto/completion-candidate.ts
import * as flatbuffers13 from "flatbuffers";
var CompletionCandidate = class _CompletionCandidate {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsCompletionCandidate(bb, obj) {
    return (obj || new _CompletionCandidate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsCompletionCandidate(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers13.SIZE_PREFIX_LENGTH);
    return (obj || new _CompletionCandidate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  displayText(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  completionText(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  /**
   * The combined tags
   */
  combinedTags() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt("0");
  }
  mutate_combined_tags(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint64(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The score
   */
  score() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_score(value) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * Is near the cursor?
   */
  nearCursor() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
  }
  mutate_near_cursor(value) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    if (offset === 0) {
      return false;
    }
    this.bb.writeInt8(this.bb_pos + offset, +value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.CompletionCandidate";
  }
  static startCompletionCandidate(builder) {
    builder.startObject(5);
  }
  static addDisplayText(builder, displayTextOffset) {
    builder.addFieldOffset(0, displayTextOffset, 0);
  }
  static addCompletionText(builder, completionTextOffset) {
    builder.addFieldOffset(1, completionTextOffset, 0);
  }
  static addCombinedTags(builder, combinedTags) {
    builder.addFieldInt64(2, combinedTags, BigInt("0"));
  }
  static addScore(builder, score) {
    builder.addFieldInt32(3, score, 0);
  }
  static addNearCursor(builder, nearCursor) {
    builder.addFieldInt8(4, +nearCursor, 0);
  }
  static endCompletionCandidate(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createCompletionCandidate(builder, displayTextOffset, completionTextOffset, combinedTags, score, nearCursor) {
    _CompletionCandidate.startCompletionCandidate(builder);
    _CompletionCandidate.addDisplayText(builder, displayTextOffset);
    _CompletionCandidate.addCompletionText(builder, completionTextOffset);
    _CompletionCandidate.addCombinedTags(builder, combinedTags);
    _CompletionCandidate.addScore(builder, score);
    _CompletionCandidate.addNearCursor(builder, nearCursor);
    return _CompletionCandidate.endCompletionCandidate(builder);
  }
  unpack() {
    return new CompletionCandidateT(
      this.displayText(),
      this.completionText(),
      this.combinedTags(),
      this.score(),
      this.nearCursor()
    );
  }
  unpackTo(_o) {
    _o.displayText = this.displayText();
    _o.completionText = this.completionText();
    _o.combinedTags = this.combinedTags();
    _o.score = this.score();
    _o.nearCursor = this.nearCursor();
  }
};
var CompletionCandidateT = class {
  constructor(displayText = null, completionText = null, combinedTags = BigInt("0"), score = 0, nearCursor = false) {
    this.displayText = displayText;
    this.completionText = completionText;
    this.combinedTags = combinedTags;
    this.score = score;
    this.nearCursor = nearCursor;
  }
  pack(builder) {
    const displayText = this.displayText !== null ? builder.createString(this.displayText) : 0;
    const completionText = this.completionText !== null ? builder.createString(this.completionText) : 0;
    return CompletionCandidate.createCompletionCandidate(
      builder,
      displayText,
      completionText,
      this.combinedTags,
      this.score,
      this.nearCursor
    );
  }
};

// gen/sqlynx/proto/completion-strategy.ts
var CompletionStrategy = /* @__PURE__ */ ((CompletionStrategy2) => {
  CompletionStrategy2[CompletionStrategy2["DEFAULT"] = 0] = "DEFAULT";
  CompletionStrategy2[CompletionStrategy2["TABLE_REF"] = 1] = "TABLE_REF";
  CompletionStrategy2[CompletionStrategy2["COLUMN_REF"] = 2] = "COLUMN_REF";
  return CompletionStrategy2;
})(CompletionStrategy || {});

// gen/sqlynx/proto/completion.ts
import * as flatbuffers14 from "flatbuffers";
var Completion = class _Completion {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsCompletion(bb, obj) {
    return (obj || new _Completion()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsCompletion(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers14.SIZE_PREFIX_LENGTH);
    return (obj || new _Completion()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  /**
   * The strategy
   */
  strategy() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0 /* DEFAULT */;
  }
  mutate_strategy(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint8(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The text offset
   */
  textOffset() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_text_offset(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The completion candidates
   */
  candidates(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new CompletionCandidate()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  candidatesLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.Completion";
  }
  static startCompletion(builder) {
    builder.startObject(3);
  }
  static addStrategy(builder, strategy) {
    builder.addFieldInt8(0, strategy, 0 /* DEFAULT */);
  }
  static addTextOffset(builder, textOffset) {
    builder.addFieldInt32(1, textOffset, 0);
  }
  static addCandidates(builder, candidatesOffset) {
    builder.addFieldOffset(2, candidatesOffset, 0);
  }
  static createCandidatesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startCandidatesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endCompletion(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createCompletion(builder, strategy, textOffset, candidatesOffset) {
    _Completion.startCompletion(builder);
    _Completion.addStrategy(builder, strategy);
    _Completion.addTextOffset(builder, textOffset);
    _Completion.addCandidates(builder, candidatesOffset);
    return _Completion.endCompletion(builder);
  }
  unpack() {
    return new CompletionT(
      this.strategy(),
      this.textOffset(),
      this.bb.createObjList(this.candidates.bind(this), this.candidatesLength())
    );
  }
  unpackTo(_o) {
    _o.strategy = this.strategy();
    _o.textOffset = this.textOffset();
    _o.candidates = this.bb.createObjList(this.candidates.bind(this), this.candidatesLength());
  }
};
var CompletionT = class {
  constructor(strategy = 0 /* DEFAULT */, textOffset = 0, candidates = []) {
    this.strategy = strategy;
    this.textOffset = textOffset;
    this.candidates = candidates;
  }
  pack(builder) {
    const candidates = Completion.createCandidatesVector(builder, builder.createObjectOffsetList(this.candidates));
    return Completion.createCompletion(
      builder,
      this.strategy,
      this.textOffset,
      candidates
    );
  }
};

// gen/sqlynx/proto/constraint-attribute.ts
var ConstraintAttribute = /* @__PURE__ */ ((ConstraintAttribute2) => {
  ConstraintAttribute2[ConstraintAttribute2["NOT_VALID"] = 0] = "NOT_VALID";
  ConstraintAttribute2[ConstraintAttribute2["NO_INHERIT"] = 1] = "NO_INHERIT";
  ConstraintAttribute2[ConstraintAttribute2["DEFERRABLE"] = 2] = "DEFERRABLE";
  ConstraintAttribute2[ConstraintAttribute2["NOT_DEFERRABLE"] = 3] = "NOT_DEFERRABLE";
  ConstraintAttribute2[ConstraintAttribute2["INITIALLY_DEFERRED"] = 4] = "INITIALLY_DEFERRED";
  ConstraintAttribute2[ConstraintAttribute2["INITIALLY_IMMEDIATE"] = 5] = "INITIALLY_IMMEDIATE";
  return ConstraintAttribute2;
})(ConstraintAttribute || {});

// gen/sqlynx/proto/error.ts
import * as flatbuffers15 from "flatbuffers";

// gen/sqlynx/proto/location.ts
var Location = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  offset() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_offset(value) {
    this.bb.writeUint32(this.bb_pos + 0, value);
    return true;
  }
  length() {
    return this.bb.readUint32(this.bb_pos + 4);
  }
  mutate_length(value) {
    this.bb.writeUint32(this.bb_pos + 4, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.Location";
  }
  static sizeOf() {
    return 8;
  }
  static createLocation(builder, offset, length) {
    builder.prep(4, 8);
    builder.writeInt32(length);
    builder.writeInt32(offset);
    return builder.offset();
  }
  unpack() {
    return new LocationT(
      this.offset(),
      this.length()
    );
  }
  unpackTo(_o) {
    _o.offset = this.offset();
    _o.length = this.length();
  }
};
var LocationT = class {
  constructor(offset = 0, length = 0) {
    this.offset = offset;
    this.length = length;
  }
  pack(builder) {
    return Location.createLocation(
      builder,
      this.offset,
      this.length
    );
  }
};

// gen/sqlynx/proto/error.ts
var Error2 = class _Error {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsError(bb, obj) {
    return (obj || new _Error()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsError(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers15.SIZE_PREFIX_LENGTH);
    return (obj || new _Error()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  location(obj) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? (obj || new Location()).__init(this.bb_pos + offset, this.bb) : null;
  }
  message(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.Error";
  }
  static startError(builder) {
    builder.startObject(2);
  }
  static addLocation(builder, locationOffset) {
    builder.addFieldStruct(0, locationOffset, 0);
  }
  static addMessage(builder, messageOffset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }
  static endError(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createError(builder, locationOffset, messageOffset) {
    _Error.startError(builder);
    _Error.addLocation(builder, locationOffset);
    _Error.addMessage(builder, messageOffset);
    return _Error.endError(builder);
  }
  unpack() {
    return new ErrorT(
      this.location() !== null ? this.location().unpack() : null,
      this.message()
    );
  }
  unpackTo(_o) {
    _o.location = this.location() !== null ? this.location().unpack() : null;
    _o.message = this.message();
  }
};
var ErrorT = class {
  constructor(location = null, message = null) {
    this.location = location;
    this.message = message;
  }
  pack(builder) {
    const message = this.message !== null ? builder.createString(this.message) : 0;
    return Error2.createError(
      builder,
      this.location !== null ? this.location.pack(builder) : 0,
      message
    );
  }
};

// gen/sqlynx/proto/extract-target.ts
var ExtractTarget = /* @__PURE__ */ ((ExtractTarget2) => {
  ExtractTarget2[ExtractTarget2["YEAR"] = 0] = "YEAR";
  ExtractTarget2[ExtractTarget2["MONTH"] = 1] = "MONTH";
  ExtractTarget2[ExtractTarget2["DAY"] = 2] = "DAY";
  ExtractTarget2[ExtractTarget2["HOUR"] = 3] = "HOUR";
  ExtractTarget2[ExtractTarget2["MINUTE"] = 4] = "MINUTE";
  ExtractTarget2[ExtractTarget2["SECOND"] = 5] = "SECOND";
  return ExtractTarget2;
})(ExtractTarget || {});

// gen/sqlynx/proto/group-by-item-type.ts
var GroupByItemType = /* @__PURE__ */ ((GroupByItemType2) => {
  GroupByItemType2[GroupByItemType2["EMPTY"] = 0] = "EMPTY";
  GroupByItemType2[GroupByItemType2["EXPRESSION"] = 1] = "EXPRESSION";
  GroupByItemType2[GroupByItemType2["CUBE"] = 2] = "CUBE";
  GroupByItemType2[GroupByItemType2["ROLLUP"] = 3] = "ROLLUP";
  GroupByItemType2[GroupByItemType2["GROUPING_SETS"] = 4] = "GROUPING_SETS";
  return GroupByItemType2;
})(GroupByItemType || {});

// gen/sqlynx/proto/interval-type.ts
var IntervalType = /* @__PURE__ */ ((IntervalType2) => {
  IntervalType2[IntervalType2["YEAR"] = 0] = "YEAR";
  IntervalType2[IntervalType2["MONTH"] = 1] = "MONTH";
  IntervalType2[IntervalType2["DAY"] = 2] = "DAY";
  IntervalType2[IntervalType2["HOUR"] = 3] = "HOUR";
  IntervalType2[IntervalType2["MINUTE"] = 4] = "MINUTE";
  IntervalType2[IntervalType2["SECOND"] = 5] = "SECOND";
  IntervalType2[IntervalType2["INTERVAL_SECOND"] = 6] = "INTERVAL_SECOND";
  IntervalType2[IntervalType2["YEAR_TO_MONTH"] = 7] = "YEAR_TO_MONTH";
  IntervalType2[IntervalType2["DAY_TO_HOUR"] = 8] = "DAY_TO_HOUR";
  IntervalType2[IntervalType2["DAY_TO_MINUTE"] = 9] = "DAY_TO_MINUTE";
  IntervalType2[IntervalType2["DAY_TO_SECOND"] = 10] = "DAY_TO_SECOND";
  IntervalType2[IntervalType2["HOUR_TO_MINUTE"] = 11] = "HOUR_TO_MINUTE";
  IntervalType2[IntervalType2["HOUR_TO_SECOND"] = 12] = "HOUR_TO_SECOND";
  IntervalType2[IntervalType2["MINUTE_TO_SECOND"] = 13] = "MINUTE_TO_SECOND";
  return IntervalType2;
})(IntervalType || {});

// gen/sqlynx/proto/join-type.ts
var JoinType = /* @__PURE__ */ ((JoinType2) => {
  JoinType2[JoinType2["NONE"] = 0] = "NONE";
  JoinType2[JoinType2["INNER"] = 1] = "INNER";
  JoinType2[JoinType2["FULL"] = 2] = "FULL";
  JoinType2[JoinType2["LEFT"] = 3] = "LEFT";
  JoinType2[JoinType2["RIGHT"] = 4] = "RIGHT";
  JoinType2[JoinType2["OUTER_"] = 64] = "OUTER_";
  JoinType2[JoinType2["OUTER_INNER_INVALID"] = 65] = "OUTER_INNER_INVALID";
  JoinType2[JoinType2["OUTER_FULL"] = 66] = "OUTER_FULL";
  JoinType2[JoinType2["OUTER_LEFT"] = 67] = "OUTER_LEFT";
  JoinType2[JoinType2["OUTER_RIGHT"] = 68] = "OUTER_RIGHT";
  JoinType2[JoinType2["NATURAL_"] = 128] = "NATURAL_";
  JoinType2[JoinType2["NATURAL_INNER"] = 129] = "NATURAL_INNER";
  JoinType2[JoinType2["NATURAL_FULL"] = 130] = "NATURAL_FULL";
  JoinType2[JoinType2["NATURAL_LEFT"] = 131] = "NATURAL_LEFT";
  JoinType2[JoinType2["NATURAL_RIGHT"] = 132] = "NATURAL_RIGHT";
  JoinType2[JoinType2["NATURAL_OUTER_"] = 192] = "NATURAL_OUTER_";
  JoinType2[JoinType2["NATURAL_OUTER_INNER_INVALID"] = 193] = "NATURAL_OUTER_INNER_INVALID";
  JoinType2[JoinType2["NATURAL_OUTER_FULL"] = 194] = "NATURAL_OUTER_FULL";
  JoinType2[JoinType2["NATURAL_OUTER_LEFT"] = 195] = "NATURAL_OUTER_LEFT";
  JoinType2[JoinType2["NATURAL_OUTER_RIGHT"] = 196] = "NATURAL_OUTER_RIGHT";
  return JoinType2;
})(JoinType || {});

// gen/sqlynx/proto/key-action-command.ts
var KeyActionCommand = /* @__PURE__ */ ((KeyActionCommand2) => {
  KeyActionCommand2[KeyActionCommand2["NO_ACTION"] = 0] = "NO_ACTION";
  KeyActionCommand2[KeyActionCommand2["RESTRICT"] = 1] = "RESTRICT";
  KeyActionCommand2[KeyActionCommand2["CASCADE"] = 2] = "CASCADE";
  KeyActionCommand2[KeyActionCommand2["SET_NULL"] = 3] = "SET_NULL";
  KeyActionCommand2[KeyActionCommand2["SET_DEFAULT"] = 4] = "SET_DEFAULT";
  return KeyActionCommand2;
})(KeyActionCommand || {});

// gen/sqlynx/proto/key-action-trigger.ts
var KeyActionTrigger = /* @__PURE__ */ ((KeyActionTrigger2) => {
  KeyActionTrigger2[KeyActionTrigger2["UPDATE"] = 0] = "UPDATE";
  KeyActionTrigger2[KeyActionTrigger2["DELETE"] = 1] = "DELETE";
  return KeyActionTrigger2;
})(KeyActionTrigger || {});

// gen/sqlynx/proto/key-match.ts
var KeyMatch = /* @__PURE__ */ ((KeyMatch2) => {
  KeyMatch2[KeyMatch2["FULL"] = 0] = "FULL";
  KeyMatch2[KeyMatch2["PARTIAL"] = 1] = "PARTIAL";
  KeyMatch2[KeyMatch2["SIMPLE"] = 2] = "SIMPLE";
  return KeyMatch2;
})(KeyMatch || {});

// gen/sqlynx/proto/known-function.ts
var KnownFunction = /* @__PURE__ */ ((KnownFunction2) => {
  KnownFunction2[KnownFunction2["COLLATION_FOR"] = 0] = "COLLATION_FOR";
  KnownFunction2[KnownFunction2["CURRENT_DATE"] = 1] = "CURRENT_DATE";
  KnownFunction2[KnownFunction2["CURRENT_TIME"] = 2] = "CURRENT_TIME";
  KnownFunction2[KnownFunction2["CURRENT_TIMESTAMP"] = 3] = "CURRENT_TIMESTAMP";
  KnownFunction2[KnownFunction2["LOCALTIME"] = 4] = "LOCALTIME";
  KnownFunction2[KnownFunction2["LOCALTIMESTAMP"] = 5] = "LOCALTIMESTAMP";
  KnownFunction2[KnownFunction2["CURRENT_ROLE"] = 6] = "CURRENT_ROLE";
  KnownFunction2[KnownFunction2["CURRENT_USER"] = 7] = "CURRENT_USER";
  KnownFunction2[KnownFunction2["SESSION_USER"] = 8] = "SESSION_USER";
  KnownFunction2[KnownFunction2["USER"] = 9] = "USER";
  KnownFunction2[KnownFunction2["CURRENT_CATALOG"] = 10] = "CURRENT_CATALOG";
  KnownFunction2[KnownFunction2["CURRENT_SCHEMA"] = 11] = "CURRENT_SCHEMA";
  KnownFunction2[KnownFunction2["CAST"] = 12] = "CAST";
  KnownFunction2[KnownFunction2["EXTRACT"] = 13] = "EXTRACT";
  KnownFunction2[KnownFunction2["OVERLAY"] = 14] = "OVERLAY";
  KnownFunction2[KnownFunction2["POSITION"] = 15] = "POSITION";
  KnownFunction2[KnownFunction2["SUBSTRING"] = 16] = "SUBSTRING";
  KnownFunction2[KnownFunction2["TREAT"] = 17] = "TREAT";
  KnownFunction2[KnownFunction2["TRIM"] = 18] = "TRIM";
  KnownFunction2[KnownFunction2["NULLIF"] = 19] = "NULLIF";
  KnownFunction2[KnownFunction2["COALESCE"] = 20] = "COALESCE";
  return KnownFunction2;
})(KnownFunction || {});

// gen/sqlynx/proto/name-tag.ts
var NameTag = /* @__PURE__ */ ((NameTag2) => {
  NameTag2[NameTag2["NONE"] = 0] = "NONE";
  NameTag2[NameTag2["KEYWORD"] = 1] = "KEYWORD";
  NameTag2[NameTag2["SCHEMA_NAME"] = 2] = "SCHEMA_NAME";
  NameTag2[NameTag2["DATABASE_NAME"] = 4] = "DATABASE_NAME";
  NameTag2[NameTag2["TABLE_NAME"] = 8] = "TABLE_NAME";
  NameTag2[NameTag2["TABLE_ALIAS"] = 16] = "TABLE_ALIAS";
  NameTag2[NameTag2["COLUMN_NAME"] = 32] = "COLUMN_NAME";
  return NameTag2;
})(NameTag || {});

// gen/sqlynx/proto/node-type.ts
var NodeType = /* @__PURE__ */ ((NodeType2) => {
  NodeType2[NodeType2["NONE"] = 0] = "NONE";
  NodeType2[NodeType2["OPERATOR"] = 1] = "OPERATOR";
  NodeType2[NodeType2["NAME"] = 2] = "NAME";
  NodeType2[NodeType2["BOOL"] = 3] = "BOOL";
  NodeType2[NodeType2["ARRAY"] = 4] = "ARRAY";
  NodeType2[NodeType2["LITERAL_NULL"] = 5] = "LITERAL_NULL";
  NodeType2[NodeType2["LITERAL_INTEGER"] = 6] = "LITERAL_INTEGER";
  NodeType2[NodeType2["LITERAL_FLOAT"] = 7] = "LITERAL_FLOAT";
  NodeType2[NodeType2["LITERAL_STRING"] = 8] = "LITERAL_STRING";
  NodeType2[NodeType2["LITERAL_INTERVAL"] = 9] = "LITERAL_INTERVAL";
  NodeType2[NodeType2["ENUM_KEYS_"] = 10] = "ENUM_KEYS_";
  NodeType2[NodeType2["ENUM_SQL_CHARACTER_TYPE"] = 11] = "ENUM_SQL_CHARACTER_TYPE";
  NodeType2[NodeType2["ENUM_SQL_COLUMN_CONSTRAINT"] = 12] = "ENUM_SQL_COLUMN_CONSTRAINT";
  NodeType2[NodeType2["ENUM_SQL_COMBINE_MODIFIER"] = 13] = "ENUM_SQL_COMBINE_MODIFIER";
  NodeType2[NodeType2["ENUM_SQL_COMBINE_OPERATION"] = 14] = "ENUM_SQL_COMBINE_OPERATION";
  NodeType2[NodeType2["ENUM_SQL_CONSTRAINT_ATTRIBUTE"] = 15] = "ENUM_SQL_CONSTRAINT_ATTRIBUTE";
  NodeType2[NodeType2["ENUM_SQL_CONST_TYPE"] = 16] = "ENUM_SQL_CONST_TYPE";
  NodeType2[NodeType2["ENUM_SQL_EXPRESSION_OPERATOR"] = 17] = "ENUM_SQL_EXPRESSION_OPERATOR";
  NodeType2[NodeType2["ENUM_SQL_EXTRACT_TARGET"] = 18] = "ENUM_SQL_EXTRACT_TARGET";
  NodeType2[NodeType2["ENUM_SQL_GROUP_BY_ITEM_TYPE"] = 19] = "ENUM_SQL_GROUP_BY_ITEM_TYPE";
  NodeType2[NodeType2["ENUM_SQL_INTERVAL_TYPE"] = 20] = "ENUM_SQL_INTERVAL_TYPE";
  NodeType2[NodeType2["ENUM_SQL_JOIN_TYPE"] = 21] = "ENUM_SQL_JOIN_TYPE";
  NodeType2[NodeType2["ENUM_SQL_KEY_ACTION_COMMAND"] = 22] = "ENUM_SQL_KEY_ACTION_COMMAND";
  NodeType2[NodeType2["ENUM_SQL_KEY_ACTION_TRIGGER"] = 23] = "ENUM_SQL_KEY_ACTION_TRIGGER";
  NodeType2[NodeType2["ENUM_SQL_KEY_MATCH"] = 24] = "ENUM_SQL_KEY_MATCH";
  NodeType2[NodeType2["ENUM_SQL_KNOWN_FUNCTION"] = 25] = "ENUM_SQL_KNOWN_FUNCTION";
  NodeType2[NodeType2["ENUM_SQL_NUMERIC_TYPE"] = 26] = "ENUM_SQL_NUMERIC_TYPE";
  NodeType2[NodeType2["ENUM_SQL_ON_COMMIT_OPTION"] = 27] = "ENUM_SQL_ON_COMMIT_OPTION";
  NodeType2[NodeType2["ENUM_SQL_ORDER_DIRECTION"] = 28] = "ENUM_SQL_ORDER_DIRECTION";
  NodeType2[NodeType2["ENUM_SQL_ORDER_NULL_RULE"] = 29] = "ENUM_SQL_ORDER_NULL_RULE";
  NodeType2[NodeType2["ENUM_SQL_ROW_LOCKING_BLOCK_BEHAVIOR"] = 30] = "ENUM_SQL_ROW_LOCKING_BLOCK_BEHAVIOR";
  NodeType2[NodeType2["ENUM_SQL_ROW_LOCKING_STRENGTH"] = 31] = "ENUM_SQL_ROW_LOCKING_STRENGTH";
  NodeType2[NodeType2["ENUM_SQL_SAMPLE_UNIT_TYPE"] = 32] = "ENUM_SQL_SAMPLE_UNIT_TYPE";
  NodeType2[NodeType2["ENUM_SQL_SUBQUERY_QUANTIFIER"] = 33] = "ENUM_SQL_SUBQUERY_QUANTIFIER";
  NodeType2[NodeType2["ENUM_SQL_TABLE_CONSTRAINT"] = 34] = "ENUM_SQL_TABLE_CONSTRAINT";
  NodeType2[NodeType2["ENUM_SQL_TEMP_TYPE"] = 35] = "ENUM_SQL_TEMP_TYPE";
  NodeType2[NodeType2["ENUM_SQL_TRIM_TARGET"] = 36] = "ENUM_SQL_TRIM_TARGET";
  NodeType2[NodeType2["ENUM_SQL_WINDOW_BOUND_DIRECTION"] = 37] = "ENUM_SQL_WINDOW_BOUND_DIRECTION";
  NodeType2[NodeType2["ENUM_SQL_WINDOW_BOUND_MODE"] = 38] = "ENUM_SQL_WINDOW_BOUND_MODE";
  NodeType2[NodeType2["ENUM_SQL_WINDOW_EXCLUSION_MODE"] = 39] = "ENUM_SQL_WINDOW_EXCLUSION_MODE";
  NodeType2[NodeType2["ENUM_SQL_WINDOW_RANGE_MODE"] = 40] = "ENUM_SQL_WINDOW_RANGE_MODE";
  NodeType2[NodeType2["OBJECT_KEYS_"] = 41] = "OBJECT_KEYS_";
  NodeType2[NodeType2["OBJECT_SQL_ALIAS"] = 42] = "OBJECT_SQL_ALIAS";
  NodeType2[NodeType2["OBJECT_SQL_BIT_TYPE"] = 43] = "OBJECT_SQL_BIT_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_CASE"] = 44] = "OBJECT_SQL_CASE";
  NodeType2[NodeType2["OBJECT_SQL_CASE_CLAUSE"] = 45] = "OBJECT_SQL_CASE_CLAUSE";
  NodeType2[NodeType2["OBJECT_SQL_CHARACTER_TYPE"] = 46] = "OBJECT_SQL_CHARACTER_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_COLUMN_CONSTRAINT"] = 47] = "OBJECT_SQL_COLUMN_CONSTRAINT";
  NodeType2[NodeType2["OBJECT_SQL_COLUMN_DEF"] = 48] = "OBJECT_SQL_COLUMN_DEF";
  NodeType2[NodeType2["OBJECT_SQL_COLUMN_REF"] = 49] = "OBJECT_SQL_COLUMN_REF";
  NodeType2[NodeType2["OBJECT_SQL_COMBINE"] = 50] = "OBJECT_SQL_COMBINE";
  NodeType2[NodeType2["OBJECT_SQL_CONST_FUNCTION_CAST"] = 51] = "OBJECT_SQL_CONST_FUNCTION_CAST";
  NodeType2[NodeType2["OBJECT_SQL_CONST_INTERVAL_CAST"] = 52] = "OBJECT_SQL_CONST_INTERVAL_CAST";
  NodeType2[NodeType2["OBJECT_SQL_CONST_TYPE_CAST"] = 53] = "OBJECT_SQL_CONST_TYPE_CAST";
  NodeType2[NodeType2["OBJECT_SQL_CREATE"] = 54] = "OBJECT_SQL_CREATE";
  NodeType2[NodeType2["OBJECT_SQL_CREATE_AS"] = 55] = "OBJECT_SQL_CREATE_AS";
  NodeType2[NodeType2["OBJECT_SQL_CTE"] = 56] = "OBJECT_SQL_CTE";
  NodeType2[NodeType2["OBJECT_SQL_DEF_ARG"] = 57] = "OBJECT_SQL_DEF_ARG";
  NodeType2[NodeType2["OBJECT_SQL_EXISTS_EXPRESSION"] = 58] = "OBJECT_SQL_EXISTS_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_ARG"] = 59] = "OBJECT_SQL_FUNCTION_ARG";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_CAST_ARGS"] = 60] = "OBJECT_SQL_FUNCTION_CAST_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_EXPRESSION"] = 61] = "OBJECT_SQL_FUNCTION_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_EXTRACT_ARGS"] = 62] = "OBJECT_SQL_FUNCTION_EXTRACT_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_OVERLAY_ARGS"] = 63] = "OBJECT_SQL_FUNCTION_OVERLAY_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_POSITION_ARGS"] = 64] = "OBJECT_SQL_FUNCTION_POSITION_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_SUBSTRING_ARGS"] = 65] = "OBJECT_SQL_FUNCTION_SUBSTRING_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_TABLE"] = 66] = "OBJECT_SQL_FUNCTION_TABLE";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_TREAT_ARGS"] = 67] = "OBJECT_SQL_FUNCTION_TREAT_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_FUNCTION_TRIM_ARGS"] = 68] = "OBJECT_SQL_FUNCTION_TRIM_ARGS";
  NodeType2[NodeType2["OBJECT_SQL_GENERIC_OPTION"] = 69] = "OBJECT_SQL_GENERIC_OPTION";
  NodeType2[NodeType2["OBJECT_SQL_GENERIC_TYPE"] = 70] = "OBJECT_SQL_GENERIC_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_GROUP_BY_ITEM"] = 71] = "OBJECT_SQL_GROUP_BY_ITEM";
  NodeType2[NodeType2["OBJECT_SQL_INDIRECTION"] = 72] = "OBJECT_SQL_INDIRECTION";
  NodeType2[NodeType2["OBJECT_SQL_INDIRECTION_INDEX"] = 73] = "OBJECT_SQL_INDIRECTION_INDEX";
  NodeType2[NodeType2["OBJECT_SQL_INTERVAL_TYPE"] = 74] = "OBJECT_SQL_INTERVAL_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_INTO"] = 75] = "OBJECT_SQL_INTO";
  NodeType2[NodeType2["OBJECT_SQL_JOINED_TABLE"] = 76] = "OBJECT_SQL_JOINED_TABLE";
  NodeType2[NodeType2["OBJECT_SQL_KEY_ACTION"] = 77] = "OBJECT_SQL_KEY_ACTION";
  NodeType2[NodeType2["OBJECT_SQL_NARY_EXPRESSION"] = 78] = "OBJECT_SQL_NARY_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_NUMERIC_TYPE"] = 79] = "OBJECT_SQL_NUMERIC_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_ORDER"] = 80] = "OBJECT_SQL_ORDER";
  NodeType2[NodeType2["OBJECT_SQL_PARAMETER_REF"] = 81] = "OBJECT_SQL_PARAMETER_REF";
  NodeType2[NodeType2["OBJECT_SQL_QUALIFIED_NAME"] = 82] = "OBJECT_SQL_QUALIFIED_NAME";
  NodeType2[NodeType2["OBJECT_SQL_QUALIFIED_OPERATOR"] = 83] = "OBJECT_SQL_QUALIFIED_OPERATOR";
  NodeType2[NodeType2["OBJECT_SQL_RELATION_EXPR"] = 84] = "OBJECT_SQL_RELATION_EXPR";
  NodeType2[NodeType2["OBJECT_SQL_RESULT_TARGET"] = 85] = "OBJECT_SQL_RESULT_TARGET";
  NodeType2[NodeType2["OBJECT_SQL_ROWSFROM_ITEM"] = 86] = "OBJECT_SQL_ROWSFROM_ITEM";
  NodeType2[NodeType2["OBJECT_SQL_ROW_LOCKING"] = 87] = "OBJECT_SQL_ROW_LOCKING";
  NodeType2[NodeType2["OBJECT_SQL_SELECT"] = 88] = "OBJECT_SQL_SELECT";
  NodeType2[NodeType2["OBJECT_SQL_SELECT_EXPRESSION"] = 89] = "OBJECT_SQL_SELECT_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_SELECT_SAMPLE"] = 90] = "OBJECT_SQL_SELECT_SAMPLE";
  NodeType2[NodeType2["OBJECT_SQL_SUBQUERY_EXPRESSION"] = 91] = "OBJECT_SQL_SUBQUERY_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_TABLEREF"] = 92] = "OBJECT_SQL_TABLEREF";
  NodeType2[NodeType2["OBJECT_SQL_TABLEREF_SAMPLE"] = 93] = "OBJECT_SQL_TABLEREF_SAMPLE";
  NodeType2[NodeType2["OBJECT_SQL_TABLE_CONSTRAINT"] = 94] = "OBJECT_SQL_TABLE_CONSTRAINT";
  NodeType2[NodeType2["OBJECT_SQL_TIMESTAMP_TYPE"] = 95] = "OBJECT_SQL_TIMESTAMP_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_TIME_TYPE"] = 96] = "OBJECT_SQL_TIME_TYPE";
  NodeType2[NodeType2["OBJECT_SQL_TYPECAST_EXPRESSION"] = 97] = "OBJECT_SQL_TYPECAST_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_TYPENAME"] = 98] = "OBJECT_SQL_TYPENAME";
  NodeType2[NodeType2["OBJECT_SQL_TYPETEST_EXPRESSION"] = 99] = "OBJECT_SQL_TYPETEST_EXPRESSION";
  NodeType2[NodeType2["OBJECT_SQL_VIEW"] = 100] = "OBJECT_SQL_VIEW";
  NodeType2[NodeType2["OBJECT_SQL_WINDOW_BOUND"] = 101] = "OBJECT_SQL_WINDOW_BOUND";
  NodeType2[NodeType2["OBJECT_SQL_WINDOW_DEF"] = 102] = "OBJECT_SQL_WINDOW_DEF";
  NodeType2[NodeType2["OBJECT_SQL_WINDOW_FRAME"] = 103] = "OBJECT_SQL_WINDOW_FRAME";
  NodeType2[NodeType2["OBJECT_SQL_WITH"] = 104] = "OBJECT_SQL_WITH";
  NodeType2[NodeType2["OBJECT_EXT_SET"] = 105] = "OBJECT_EXT_SET";
  NodeType2[NodeType2["OBJECT_EXT_VARARG_ARRAY"] = 106] = "OBJECT_EXT_VARARG_ARRAY";
  NodeType2[NodeType2["OBJECT_EXT_VARARG_FIELD"] = 107] = "OBJECT_EXT_VARARG_FIELD";
  return NodeType2;
})(NodeType || {});

// gen/sqlynx/proto/node.ts
var Node = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  location(obj) {
    return (obj || new Location()).__init(this.bb_pos, this.bb);
  }
  nodeType() {
    return this.bb.readUint16(this.bb_pos + 8);
  }
  mutate_node_type(value) {
    this.bb.writeUint16(this.bb_pos + 8, value);
    return true;
  }
  attributeKey() {
    return this.bb.readUint16(this.bb_pos + 10);
  }
  mutate_attribute_key(value) {
    this.bb.writeUint16(this.bb_pos + 10, value);
    return true;
  }
  parent() {
    return this.bb.readUint32(this.bb_pos + 12);
  }
  mutate_parent(value) {
    this.bb.writeUint32(this.bb_pos + 12, value);
    return true;
  }
  childrenBeginOrValue() {
    return this.bb.readUint32(this.bb_pos + 16);
  }
  mutate_children_begin_or_value(value) {
    this.bb.writeUint32(this.bb_pos + 16, value);
    return true;
  }
  childrenCount() {
    return this.bb.readUint32(this.bb_pos + 20);
  }
  mutate_children_count(value) {
    this.bb.writeUint32(this.bb_pos + 20, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.Node";
  }
  static sizeOf() {
    return 24;
  }
  static createNode(builder, location_offset, location_length, node_type, attribute_key, parent, children_begin_or_value, children_count) {
    builder.prep(4, 24);
    builder.writeInt32(children_count);
    builder.writeInt32(children_begin_or_value);
    builder.writeInt32(parent);
    builder.writeInt16(attribute_key);
    builder.writeInt16(node_type);
    builder.prep(4, 8);
    builder.writeInt32(location_length);
    builder.writeInt32(location_offset);
    return builder.offset();
  }
  unpack() {
    return new NodeT(
      this.location() !== null ? this.location().unpack() : null,
      this.nodeType(),
      this.attributeKey(),
      this.parent(),
      this.childrenBeginOrValue(),
      this.childrenCount()
    );
  }
  unpackTo(_o) {
    _o.location = this.location() !== null ? this.location().unpack() : null;
    _o.nodeType = this.nodeType();
    _o.attributeKey = this.attributeKey();
    _o.parent = this.parent();
    _o.childrenBeginOrValue = this.childrenBeginOrValue();
    _o.childrenCount = this.childrenCount();
  }
};
var NodeT = class {
  constructor(location = null, nodeType = 0 /* NONE */, attributeKey = 0 /* NONE */, parent = 0, childrenBeginOrValue = 0, childrenCount = 0) {
    this.location = location;
    this.nodeType = nodeType;
    this.attributeKey = attributeKey;
    this.parent = parent;
    this.childrenBeginOrValue = childrenBeginOrValue;
    this.childrenCount = childrenCount;
  }
  pack(builder) {
    return Node.createNode(
      builder,
      this.location?.offset ?? 0,
      this.location?.length ?? 0,
      this.nodeType,
      this.attributeKey,
      this.parent,
      this.childrenBeginOrValue,
      this.childrenCount
    );
  }
};

// gen/sqlynx/proto/numeric-type.ts
var NumericType = /* @__PURE__ */ ((NumericType2) => {
  NumericType2[NumericType2["INT1"] = 0] = "INT1";
  NumericType2[NumericType2["INT2"] = 1] = "INT2";
  NumericType2[NumericType2["INT4"] = 2] = "INT4";
  NumericType2[NumericType2["INT8"] = 3] = "INT8";
  NumericType2[NumericType2["FLOAT4"] = 4] = "FLOAT4";
  NumericType2[NumericType2["FLOAT8"] = 5] = "FLOAT8";
  NumericType2[NumericType2["NUMERIC"] = 6] = "NUMERIC";
  NumericType2[NumericType2["BOOL"] = 7] = "BOOL";
  return NumericType2;
})(NumericType || {});

// gen/sqlynx/proto/on-commit-option.ts
var OnCommitOption = /* @__PURE__ */ ((OnCommitOption2) => {
  OnCommitOption2[OnCommitOption2["DROP"] = 0] = "DROP";
  OnCommitOption2[OnCommitOption2["DELETE_ROWS"] = 1] = "DELETE_ROWS";
  OnCommitOption2[OnCommitOption2["PRESERVE_ROWS"] = 2] = "PRESERVE_ROWS";
  OnCommitOption2[OnCommitOption2["NOOP"] = 3] = "NOOP";
  return OnCommitOption2;
})(OnCommitOption || {});

// gen/sqlynx/proto/order-direction.ts
var OrderDirection = /* @__PURE__ */ ((OrderDirection2) => {
  OrderDirection2[OrderDirection2["ASCENDING"] = 0] = "ASCENDING";
  OrderDirection2[OrderDirection2["DESCENDING"] = 1] = "DESCENDING";
  return OrderDirection2;
})(OrderDirection || {});

// gen/sqlynx/proto/order-null-rule.ts
var OrderNullRule = /* @__PURE__ */ ((OrderNullRule2) => {
  OrderNullRule2[OrderNullRule2["NULLS_FIRST"] = 0] = "NULLS_FIRST";
  OrderNullRule2[OrderNullRule2["NULLS_LAST"] = 1] = "NULLS_LAST";
  return OrderNullRule2;
})(OrderNullRule || {});

// gen/sqlynx/proto/parsed-script.ts
import * as flatbuffers17 from "flatbuffers";

// gen/sqlynx/proto/statement.ts
import * as flatbuffers16 from "flatbuffers";

// gen/sqlynx/proto/statement-type.ts
var StatementType = /* @__PURE__ */ ((StatementType2) => {
  StatementType2[StatementType2["NONE"] = 0] = "NONE";
  StatementType2[StatementType2["CREATE_TABLE"] = 1] = "CREATE_TABLE";
  StatementType2[StatementType2["CREATE_TABLE_AS"] = 2] = "CREATE_TABLE_AS";
  StatementType2[StatementType2["CREATE_VIEW"] = 3] = "CREATE_VIEW";
  StatementType2[StatementType2["SELECT"] = 4] = "SELECT";
  StatementType2[StatementType2["SET"] = 5] = "SET";
  return StatementType2;
})(StatementType || {});

// gen/sqlynx/proto/statement.ts
var Statement = class _Statement {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsStatement(bb, obj) {
    return (obj || new _Statement()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsStatement(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers16.SIZE_PREFIX_LENGTH);
    return (obj || new _Statement()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  statementType() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0 /* NONE */;
  }
  mutate_statement_type(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint8(this.bb_pos + offset, value);
    return true;
  }
  rootNode() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_root_node(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  nodesBegin() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_nodes_begin(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  nodeCount() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_node_count(value) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.Statement";
  }
  static startStatement(builder) {
    builder.startObject(4);
  }
  static addStatementType(builder, statementType) {
    builder.addFieldInt8(0, statementType, 0 /* NONE */);
  }
  static addRootNode(builder, rootNode) {
    builder.addFieldInt32(1, rootNode, 0);
  }
  static addNodesBegin(builder, nodesBegin) {
    builder.addFieldInt32(2, nodesBegin, 0);
  }
  static addNodeCount(builder, nodeCount) {
    builder.addFieldInt32(3, nodeCount, 0);
  }
  static endStatement(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createStatement(builder, statementType, rootNode, nodesBegin, nodeCount) {
    _Statement.startStatement(builder);
    _Statement.addStatementType(builder, statementType);
    _Statement.addRootNode(builder, rootNode);
    _Statement.addNodesBegin(builder, nodesBegin);
    _Statement.addNodeCount(builder, nodeCount);
    return _Statement.endStatement(builder);
  }
  unpack() {
    return new StatementT(
      this.statementType(),
      this.rootNode(),
      this.nodesBegin(),
      this.nodeCount()
    );
  }
  unpackTo(_o) {
    _o.statementType = this.statementType();
    _o.rootNode = this.rootNode();
    _o.nodesBegin = this.nodesBegin();
    _o.nodeCount = this.nodeCount();
  }
};
var StatementT = class {
  constructor(statementType = 0 /* NONE */, rootNode = 0, nodesBegin = 0, nodeCount = 0) {
    this.statementType = statementType;
    this.rootNode = rootNode;
    this.nodesBegin = nodesBegin;
    this.nodeCount = nodeCount;
  }
  pack(builder) {
    return Statement.createStatement(
      builder,
      this.statementType,
      this.rootNode,
      this.nodesBegin,
      this.nodeCount
    );
  }
};

// gen/sqlynx/proto/parsed-script.ts
var ParsedScript = class _ParsedScript {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsParsedScript(bb, obj) {
    return (obj || new _ParsedScript()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsParsedScript(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers17.SIZE_PREFIX_LENGTH);
    return (obj || new _ParsedScript()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  externalId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_external_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  nodes(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? (obj || new Node()).__init(this.bb.__vector(this.bb_pos + offset) + index * 24, this.bb) : null;
  }
  nodesLength() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  statements(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new Statement()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  statementsLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  errors(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new Error2()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  errorsLength() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ParsedScript";
  }
  static startParsedScript(builder) {
    builder.startObject(4);
  }
  static addExternalId(builder, externalId) {
    builder.addFieldInt32(0, externalId, 0);
  }
  static addNodes(builder, nodesOffset) {
    builder.addFieldOffset(1, nodesOffset, 0);
  }
  static startNodesVector(builder, numElems) {
    builder.startVector(24, numElems, 4);
  }
  static addStatements(builder, statementsOffset) {
    builder.addFieldOffset(2, statementsOffset, 0);
  }
  static createStatementsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startStatementsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addErrors(builder, errorsOffset) {
    builder.addFieldOffset(3, errorsOffset, 0);
  }
  static createErrorsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startErrorsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endParsedScript(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createParsedScript(builder, externalId, nodesOffset, statementsOffset, errorsOffset) {
    _ParsedScript.startParsedScript(builder);
    _ParsedScript.addExternalId(builder, externalId);
    _ParsedScript.addNodes(builder, nodesOffset);
    _ParsedScript.addStatements(builder, statementsOffset);
    _ParsedScript.addErrors(builder, errorsOffset);
    return _ParsedScript.endParsedScript(builder);
  }
  unpack() {
    return new ParsedScriptT(
      this.externalId(),
      this.bb.createObjList(this.nodes.bind(this), this.nodesLength()),
      this.bb.createObjList(this.statements.bind(this), this.statementsLength()),
      this.bb.createObjList(this.errors.bind(this), this.errorsLength())
    );
  }
  unpackTo(_o) {
    _o.externalId = this.externalId();
    _o.nodes = this.bb.createObjList(this.nodes.bind(this), this.nodesLength());
    _o.statements = this.bb.createObjList(this.statements.bind(this), this.statementsLength());
    _o.errors = this.bb.createObjList(this.errors.bind(this), this.errorsLength());
  }
};
var ParsedScriptT = class {
  constructor(externalId = 0, nodes = [], statements = [], errors = []) {
    this.externalId = externalId;
    this.nodes = nodes;
    this.statements = statements;
    this.errors = errors;
  }
  pack(builder) {
    const nodes = builder.createStructOffsetList(this.nodes, ParsedScript.startNodesVector);
    const statements = ParsedScript.createStatementsVector(builder, builder.createObjectOffsetList(this.statements));
    const errors = ParsedScript.createErrorsVector(builder, builder.createObjectOffsetList(this.errors));
    return ParsedScript.createParsedScript(
      builder,
      this.externalId,
      nodes,
      statements,
      errors
    );
  }
};

// gen/sqlynx/proto/query-graph-layout-edge-node.ts
var QueryGraphLayoutEdgeNode = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The table id
   */
  tableId() {
    return this.bb.readUint64(this.bb_pos);
  }
  mutate_table_id(value) {
    this.bb.writeUint64(this.bb_pos + 0, value);
    return true;
  }
  /**
   * The column reference id
   */
  columnReferenceId() {
    return this.bb.readUint64(this.bb_pos + 8);
  }
  mutate_column_reference_id(value) {
    this.bb.writeUint64(this.bb_pos + 8, value);
    return true;
  }
  /**
   * The ast node id
   */
  astNodeId() {
    return this.bb.readUint64(this.bb_pos + 16);
  }
  mutate_ast_node_id(value) {
    this.bb.writeUint64(this.bb_pos + 16, value);
    return true;
  }
  /**
   * The node id
   */
  nodeId() {
    return this.bb.readUint32(this.bb_pos + 24);
  }
  mutate_node_id(value) {
    this.bb.writeUint32(this.bb_pos + 24, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphLayoutEdgeNode";
  }
  static sizeOf() {
    return 32;
  }
  static createQueryGraphLayoutEdgeNode(builder, table_id, column_reference_id, ast_node_id, node_id) {
    builder.prep(8, 32);
    builder.pad(4);
    builder.writeInt32(node_id);
    builder.writeInt64(BigInt(ast_node_id ?? 0));
    builder.writeInt64(BigInt(column_reference_id ?? 0));
    builder.writeInt64(BigInt(table_id ?? 0));
    return builder.offset();
  }
  unpack() {
    return new QueryGraphLayoutEdgeNodeT(
      this.tableId(),
      this.columnReferenceId(),
      this.astNodeId(),
      this.nodeId()
    );
  }
  unpackTo(_o) {
    _o.tableId = this.tableId();
    _o.columnReferenceId = this.columnReferenceId();
    _o.astNodeId = this.astNodeId();
    _o.nodeId = this.nodeId();
  }
};
var QueryGraphLayoutEdgeNodeT = class {
  constructor(tableId = BigInt("0"), columnReferenceId = BigInt("0"), astNodeId = BigInt("0"), nodeId = 0) {
    this.tableId = tableId;
    this.columnReferenceId = columnReferenceId;
    this.astNodeId = astNodeId;
    this.nodeId = nodeId;
  }
  pack(builder) {
    return QueryGraphLayoutEdgeNode.createQueryGraphLayoutEdgeNode(
      builder,
      this.tableId,
      this.columnReferenceId,
      this.astNodeId,
      this.nodeId
    );
  }
};

// gen/sqlynx/proto/query-graph-layout-edge.ts
var QueryGraphLayoutEdge = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The edge id of the analyzer query graph
   */
  queryEdgeId() {
    return this.bb.readUint64(this.bb_pos);
  }
  mutate_query_edge_id(value) {
    this.bb.writeUint64(this.bb_pos + 0, value);
    return true;
  }
  /**
   * The ast node id
   */
  astNodeId() {
    return this.bb.readUint64(this.bb_pos + 8);
  }
  mutate_ast_node_id(value) {
    this.bb.writeUint64(this.bb_pos + 8, value);
    return true;
  }
  /**
   * The begin of the nodes
   */
  nodesBegin() {
    return this.bb.readUint32(this.bb_pos + 16);
  }
  mutate_nodes_begin(value) {
    this.bb.writeUint32(this.bb_pos + 16, value);
    return true;
  }
  /**
   * The number of nodes on the left side
   */
  nodeCountLeft() {
    return this.bb.readUint16(this.bb_pos + 20);
  }
  mutate_node_count_left(value) {
    this.bb.writeUint16(this.bb_pos + 20, value);
    return true;
  }
  /**
   * The set id of nodes on the right side
   */
  nodeCountRight() {
    return this.bb.readUint16(this.bb_pos + 22);
  }
  mutate_node_count_right(value) {
    this.bb.writeUint16(this.bb_pos + 22, value);
    return true;
  }
  /**
   * The expression operator
   */
  expressionOperator() {
    return this.bb.readUint8(this.bb_pos + 24);
  }
  mutate_expression_operator(value) {
    this.bb.writeUint8(this.bb_pos + 24, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphLayoutEdge";
  }
  static sizeOf() {
    return 32;
  }
  static createQueryGraphLayoutEdge(builder, query_edge_id, ast_node_id, nodes_begin, node_count_left, node_count_right, expression_operator) {
    builder.prep(8, 32);
    builder.pad(7);
    builder.writeInt8(expression_operator);
    builder.writeInt16(node_count_right);
    builder.writeInt16(node_count_left);
    builder.writeInt32(nodes_begin);
    builder.writeInt64(BigInt(ast_node_id ?? 0));
    builder.writeInt64(BigInt(query_edge_id ?? 0));
    return builder.offset();
  }
  unpack() {
    return new QueryGraphLayoutEdgeT(
      this.queryEdgeId(),
      this.astNodeId(),
      this.nodesBegin(),
      this.nodeCountLeft(),
      this.nodeCountRight(),
      this.expressionOperator()
    );
  }
  unpackTo(_o) {
    _o.queryEdgeId = this.queryEdgeId();
    _o.astNodeId = this.astNodeId();
    _o.nodesBegin = this.nodesBegin();
    _o.nodeCountLeft = this.nodeCountLeft();
    _o.nodeCountRight = this.nodeCountRight();
    _o.expressionOperator = this.expressionOperator();
  }
};
var QueryGraphLayoutEdgeT = class {
  constructor(queryEdgeId = BigInt("0"), astNodeId = BigInt("0"), nodesBegin = 0, nodeCountLeft = 0, nodeCountRight = 0, expressionOperator = 0 /* DEFAULT */) {
    this.queryEdgeId = queryEdgeId;
    this.astNodeId = astNodeId;
    this.nodesBegin = nodesBegin;
    this.nodeCountLeft = nodeCountLeft;
    this.nodeCountRight = nodeCountRight;
    this.expressionOperator = expressionOperator;
  }
  pack(builder) {
    return QueryGraphLayoutEdge.createQueryGraphLayoutEdge(
      builder,
      this.queryEdgeId,
      this.astNodeId,
      this.nodesBegin,
      this.nodeCountLeft,
      this.nodeCountRight,
      this.expressionOperator
    );
  }
};

// gen/sqlynx/proto/query-graph-layout-table-node.ts
import * as flatbuffers18 from "flatbuffers";

// gen/sqlynx/proto/query-graph-layout-vertex.ts
var QueryGraphLayoutVertex = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  x() {
    return this.bb.readFloat64(this.bb_pos);
  }
  mutate_x(value) {
    this.bb.writeFloat64(this.bb_pos + 0, value);
    return true;
  }
  y() {
    return this.bb.readFloat64(this.bb_pos + 8);
  }
  mutate_y(value) {
    this.bb.writeFloat64(this.bb_pos + 8, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphLayoutVertex";
  }
  static sizeOf() {
    return 16;
  }
  static createQueryGraphLayoutVertex(builder, x, y) {
    builder.prep(8, 16);
    builder.writeFloat64(y);
    builder.writeFloat64(x);
    return builder.offset();
  }
  unpack() {
    return new QueryGraphLayoutVertexT(
      this.x(),
      this.y()
    );
  }
  unpackTo(_o) {
    _o.x = this.x();
    _o.y = this.y();
  }
};
var QueryGraphLayoutVertexT = class {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
  pack(builder) {
    return QueryGraphLayoutVertex.createQueryGraphLayoutVertex(
      builder,
      this.x,
      this.y
    );
  }
};

// gen/sqlynx/proto/query-graph-layout-table-node.ts
var QueryGraphLayoutTableNode = class _QueryGraphLayoutTableNode {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsQueryGraphLayoutTableNode(bb, obj) {
    return (obj || new _QueryGraphLayoutTableNode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsQueryGraphLayoutTableNode(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers18.SIZE_PREFIX_LENGTH);
    return (obj || new _QueryGraphLayoutTableNode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  /**
   * The id of table
   */
  tableId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt("0");
  }
  mutate_table_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint64(this.bb_pos + offset, value);
    return true;
  }
  tableName(optionalEncoding) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
  }
  /**
   * The position
   */
  position(obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new QueryGraphLayoutVertex()).__init(this.bb_pos + offset, this.bb) : null;
  }
  /**
   * The node width
   */
  width() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0;
  }
  mutate_width(value) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    if (offset === 0) {
      return false;
    }
    this.bb.writeFloat64(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The node height
   */
  height() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0;
  }
  mutate_height(value) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    if (offset === 0) {
      return false;
    }
    this.bb.writeFloat64(this.bb_pos + offset, value);
    return true;
  }
  /**
   * Is referenced?
   */
  isReferenced() {
    const offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
  }
  mutate_is_referenced(value) {
    const offset = this.bb.__offset(this.bb_pos, 14);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint8(this.bb_pos + offset, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphLayoutTableNode";
  }
  static startQueryGraphLayoutTableNode(builder) {
    builder.startObject(6);
  }
  static addTableId(builder, tableId) {
    builder.addFieldInt64(0, tableId, BigInt("0"));
  }
  static addTableName(builder, tableNameOffset) {
    builder.addFieldOffset(1, tableNameOffset, 0);
  }
  static addPosition(builder, positionOffset) {
    builder.addFieldStruct(2, positionOffset, 0);
  }
  static addWidth(builder, width) {
    builder.addFieldFloat64(3, width, 0);
  }
  static addHeight(builder, height) {
    builder.addFieldFloat64(4, height, 0);
  }
  static addIsReferenced(builder, isReferenced) {
    builder.addFieldInt8(5, isReferenced, 0);
  }
  static endQueryGraphLayoutTableNode(builder) {
    const offset = builder.endObject();
    return offset;
  }
  unpack() {
    return new QueryGraphLayoutTableNodeT(
      this.tableId(),
      this.tableName(),
      this.position() !== null ? this.position().unpack() : null,
      this.width(),
      this.height(),
      this.isReferenced()
    );
  }
  unpackTo(_o) {
    _o.tableId = this.tableId();
    _o.tableName = this.tableName();
    _o.position = this.position() !== null ? this.position().unpack() : null;
    _o.width = this.width();
    _o.height = this.height();
    _o.isReferenced = this.isReferenced();
  }
};
var QueryGraphLayoutTableNodeT = class {
  constructor(tableId = BigInt("0"), tableName = null, position = null, width = 0, height = 0, isReferenced = 0) {
    this.tableId = tableId;
    this.tableName = tableName;
    this.position = position;
    this.width = width;
    this.height = height;
    this.isReferenced = isReferenced;
  }
  pack(builder) {
    const tableName = this.tableName !== null ? builder.createString(this.tableName) : 0;
    QueryGraphLayoutTableNode.startQueryGraphLayoutTableNode(builder);
    QueryGraphLayoutTableNode.addTableId(builder, this.tableId);
    QueryGraphLayoutTableNode.addTableName(builder, tableName);
    QueryGraphLayoutTableNode.addPosition(builder, this.position !== null ? this.position.pack(builder) : 0);
    QueryGraphLayoutTableNode.addWidth(builder, this.width);
    QueryGraphLayoutTableNode.addHeight(builder, this.height);
    QueryGraphLayoutTableNode.addIsReferenced(builder, this.isReferenced);
    return QueryGraphLayoutTableNode.endQueryGraphLayoutTableNode(builder);
  }
};

// gen/sqlynx/proto/query-graph-layout.ts
import * as flatbuffers19 from "flatbuffers";
var QueryGraphLayout = class _QueryGraphLayout {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsQueryGraphLayout(bb, obj) {
    return (obj || new _QueryGraphLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsQueryGraphLayout(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers19.SIZE_PREFIX_LENGTH);
    return (obj || new _QueryGraphLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  /**
   * The table nodes
   */
  tableNodes(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? (obj || new QueryGraphLayoutTableNode()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  tableNodesLength() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  /**
   * The edge
   */
  edgeNodes(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? (obj || new QueryGraphLayoutEdgeNode()).__init(this.bb.__vector(this.bb_pos + offset) + index * 32, this.bb) : null;
  }
  edgeNodesLength() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  /**
   * The edges
   */
  edges(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new QueryGraphLayoutEdge()).__init(this.bb.__vector(this.bb_pos + offset) + index * 32, this.bb) : null;
  }
  edgesLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.QueryGraphLayout";
  }
  static startQueryGraphLayout(builder) {
    builder.startObject(3);
  }
  static addTableNodes(builder, tableNodesOffset) {
    builder.addFieldOffset(0, tableNodesOffset, 0);
  }
  static createTableNodesVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startTableNodesVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addEdgeNodes(builder, edgeNodesOffset) {
    builder.addFieldOffset(1, edgeNodesOffset, 0);
  }
  static startEdgeNodesVector(builder, numElems) {
    builder.startVector(32, numElems, 8);
  }
  static addEdges(builder, edgesOffset) {
    builder.addFieldOffset(2, edgesOffset, 0);
  }
  static startEdgesVector(builder, numElems) {
    builder.startVector(32, numElems, 8);
  }
  static endQueryGraphLayout(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createQueryGraphLayout(builder, tableNodesOffset, edgeNodesOffset, edgesOffset) {
    _QueryGraphLayout.startQueryGraphLayout(builder);
    _QueryGraphLayout.addTableNodes(builder, tableNodesOffset);
    _QueryGraphLayout.addEdgeNodes(builder, edgeNodesOffset);
    _QueryGraphLayout.addEdges(builder, edgesOffset);
    return _QueryGraphLayout.endQueryGraphLayout(builder);
  }
  unpack() {
    return new QueryGraphLayoutT(
      this.bb.createObjList(this.tableNodes.bind(this), this.tableNodesLength()),
      this.bb.createObjList(this.edgeNodes.bind(this), this.edgeNodesLength()),
      this.bb.createObjList(this.edges.bind(this), this.edgesLength())
    );
  }
  unpackTo(_o) {
    _o.tableNodes = this.bb.createObjList(this.tableNodes.bind(this), this.tableNodesLength());
    _o.edgeNodes = this.bb.createObjList(this.edgeNodes.bind(this), this.edgeNodesLength());
    _o.edges = this.bb.createObjList(this.edges.bind(this), this.edgesLength());
  }
};
var QueryGraphLayoutT = class {
  constructor(tableNodes = [], edgeNodes = [], edges = []) {
    this.tableNodes = tableNodes;
    this.edgeNodes = edgeNodes;
    this.edges = edges;
  }
  pack(builder) {
    const tableNodes = QueryGraphLayout.createTableNodesVector(builder, builder.createObjectOffsetList(this.tableNodes));
    const edgeNodes = builder.createStructOffsetList(this.edgeNodes, QueryGraphLayout.startEdgeNodesVector);
    const edges = builder.createStructOffsetList(this.edges, QueryGraphLayout.startEdgesVector);
    return QueryGraphLayout.createQueryGraphLayout(
      builder,
      tableNodes,
      edgeNodes,
      edges
    );
  }
};

// gen/sqlynx/proto/relative-symbol-position.ts
var RelativeSymbolPosition = /* @__PURE__ */ ((RelativeSymbolPosition2) => {
  RelativeSymbolPosition2[RelativeSymbolPosition2["NEW_SYMBOL_BEFORE"] = 0] = "NEW_SYMBOL_BEFORE";
  RelativeSymbolPosition2[RelativeSymbolPosition2["NEW_SYMBOL_AFTER"] = 1] = "NEW_SYMBOL_AFTER";
  RelativeSymbolPosition2[RelativeSymbolPosition2["BEGIN_OF_SYMBOL"] = 2] = "BEGIN_OF_SYMBOL";
  RelativeSymbolPosition2[RelativeSymbolPosition2["MID_OF_SYMBOL"] = 3] = "MID_OF_SYMBOL";
  RelativeSymbolPosition2[RelativeSymbolPosition2["END_OF_SYMBOL"] = 4] = "END_OF_SYMBOL";
  return RelativeSymbolPosition2;
})(RelativeSymbolPosition || {});

// gen/sqlynx/proto/row-locking-block-behavior.ts
var RowLockingBlockBehavior = /* @__PURE__ */ ((RowLockingBlockBehavior2) => {
  RowLockingBlockBehavior2[RowLockingBlockBehavior2["NOWAIT"] = 0] = "NOWAIT";
  RowLockingBlockBehavior2[RowLockingBlockBehavior2["SKIP_LOCKED"] = 1] = "SKIP_LOCKED";
  return RowLockingBlockBehavior2;
})(RowLockingBlockBehavior || {});

// gen/sqlynx/proto/row-locking-strength.ts
var RowLockingStrength = /* @__PURE__ */ ((RowLockingStrength2) => {
  RowLockingStrength2[RowLockingStrength2["UPDATE"] = 0] = "UPDATE";
  RowLockingStrength2[RowLockingStrength2["NO_KEY_UPDATE"] = 1] = "NO_KEY_UPDATE";
  RowLockingStrength2[RowLockingStrength2["SHARE"] = 2] = "SHARE";
  RowLockingStrength2[RowLockingStrength2["KEY_SHARE"] = 3] = "KEY_SHARE";
  RowLockingStrength2[RowLockingStrength2["READ_ONLY"] = 4] = "READ_ONLY";
  return RowLockingStrength2;
})(RowLockingStrength || {});

// gen/sqlynx/proto/sample-count-unit.ts
var SampleCountUnit = /* @__PURE__ */ ((SampleCountUnit2) => {
  SampleCountUnit2[SampleCountUnit2["PERCENT"] = 0] = "PERCENT";
  SampleCountUnit2[SampleCountUnit2["ROWS"] = 1] = "ROWS";
  return SampleCountUnit2;
})(SampleCountUnit || {});

// gen/sqlynx/proto/scanned-script.ts
import * as flatbuffers21 from "flatbuffers";

// gen/sqlynx/proto/scanner-tokens.ts
import * as flatbuffers20 from "flatbuffers";
var ScannerTokens = class _ScannerTokens {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsScannerTokens(bb, obj) {
    return (obj || new _ScannerTokens()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsScannerTokens(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers20.SIZE_PREFIX_LENGTH);
    return (obj || new _ScannerTokens()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  tokenOffsets(index) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
  }
  tokenOffsetsLength() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  tokenOffsetsArray() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
  }
  tokenLengths(index) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
  }
  tokenLengthsLength() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  tokenLengthsArray() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
  }
  tokenTypes(index) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
  }
  tokenTypesLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  tokenTypesArray() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
  }
  tokenBreaks(index) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
  }
  tokenBreaksLength() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  tokenBreaksArray() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScannerTokens";
  }
  static startScannerTokens(builder) {
    builder.startObject(4);
  }
  static addTokenOffsets(builder, tokenOffsetsOffset) {
    builder.addFieldOffset(0, tokenOffsetsOffset, 0);
  }
  static createTokenOffsetsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]);
    }
    return builder.endVector();
  }
  static startTokenOffsetsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addTokenLengths(builder, tokenLengthsOffset) {
    builder.addFieldOffset(1, tokenLengthsOffset, 0);
  }
  static createTokenLengthsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]);
    }
    return builder.endVector();
  }
  static startTokenLengthsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addTokenTypes(builder, tokenTypesOffset) {
    builder.addFieldOffset(2, tokenTypesOffset, 0);
  }
  static createTokenTypesVector(builder, data) {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]);
    }
    return builder.endVector();
  }
  static startTokenTypesVector(builder, numElems) {
    builder.startVector(1, numElems, 1);
  }
  static addTokenBreaks(builder, tokenBreaksOffset) {
    builder.addFieldOffset(3, tokenBreaksOffset, 0);
  }
  static createTokenBreaksVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]);
    }
    return builder.endVector();
  }
  static startTokenBreaksVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static endScannerTokens(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createScannerTokens(builder, tokenOffsetsOffset, tokenLengthsOffset, tokenTypesOffset, tokenBreaksOffset) {
    _ScannerTokens.startScannerTokens(builder);
    _ScannerTokens.addTokenOffsets(builder, tokenOffsetsOffset);
    _ScannerTokens.addTokenLengths(builder, tokenLengthsOffset);
    _ScannerTokens.addTokenTypes(builder, tokenTypesOffset);
    _ScannerTokens.addTokenBreaks(builder, tokenBreaksOffset);
    return _ScannerTokens.endScannerTokens(builder);
  }
  unpack() {
    return new ScannerTokensT(
      this.bb.createScalarList(this.tokenOffsets.bind(this), this.tokenOffsetsLength()),
      this.bb.createScalarList(this.tokenLengths.bind(this), this.tokenLengthsLength()),
      this.bb.createScalarList(this.tokenTypes.bind(this), this.tokenTypesLength()),
      this.bb.createScalarList(this.tokenBreaks.bind(this), this.tokenBreaksLength())
    );
  }
  unpackTo(_o) {
    _o.tokenOffsets = this.bb.createScalarList(this.tokenOffsets.bind(this), this.tokenOffsetsLength());
    _o.tokenLengths = this.bb.createScalarList(this.tokenLengths.bind(this), this.tokenLengthsLength());
    _o.tokenTypes = this.bb.createScalarList(this.tokenTypes.bind(this), this.tokenTypesLength());
    _o.tokenBreaks = this.bb.createScalarList(this.tokenBreaks.bind(this), this.tokenBreaksLength());
  }
};
var ScannerTokensT = class {
  constructor(tokenOffsets = [], tokenLengths = [], tokenTypes = [], tokenBreaks = []) {
    this.tokenOffsets = tokenOffsets;
    this.tokenLengths = tokenLengths;
    this.tokenTypes = tokenTypes;
    this.tokenBreaks = tokenBreaks;
  }
  pack(builder) {
    const tokenOffsets = ScannerTokens.createTokenOffsetsVector(builder, this.tokenOffsets);
    const tokenLengths = ScannerTokens.createTokenLengthsVector(builder, this.tokenLengths);
    const tokenTypes = ScannerTokens.createTokenTypesVector(builder, this.tokenTypes);
    const tokenBreaks = ScannerTokens.createTokenBreaksVector(builder, this.tokenBreaks);
    return ScannerTokens.createScannerTokens(
      builder,
      tokenOffsets,
      tokenLengths,
      tokenTypes,
      tokenBreaks
    );
  }
};

// gen/sqlynx/proto/scanned-script.ts
var ScannedScript = class _ScannedScript {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsScannedScript(bb, obj) {
    return (obj || new _ScannedScript()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsScannedScript(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers21.SIZE_PREFIX_LENGTH);
    return (obj || new _ScannedScript()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  externalId() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_external_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  lineBreaks(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? (obj || new Location()).__init(this.bb.__vector(this.bb_pos + offset) + index * 8, this.bb) : null;
  }
  lineBreaksLength() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  errors(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? (obj || new Error2()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
  }
  errorsLength() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  tokens(obj) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? (obj || new ScannerTokens()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
  }
  comments(index, obj) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? (obj || new Location()).__init(this.bb.__vector(this.bb_pos + offset) + index * 8, this.bb) : null;
  }
  commentsLength() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScannedScript";
  }
  static startScannedScript(builder) {
    builder.startObject(5);
  }
  static addExternalId(builder, externalId) {
    builder.addFieldInt32(0, externalId, 0);
  }
  static addLineBreaks(builder, lineBreaksOffset) {
    builder.addFieldOffset(1, lineBreaksOffset, 0);
  }
  static startLineBreaksVector(builder, numElems) {
    builder.startVector(8, numElems, 4);
  }
  static addErrors(builder, errorsOffset) {
    builder.addFieldOffset(2, errorsOffset, 0);
  }
  static createErrorsVector(builder, data) {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]);
    }
    return builder.endVector();
  }
  static startErrorsVector(builder, numElems) {
    builder.startVector(4, numElems, 4);
  }
  static addTokens(builder, tokensOffset) {
    builder.addFieldOffset(3, tokensOffset, 0);
  }
  static addComments(builder, commentsOffset) {
    builder.addFieldOffset(4, commentsOffset, 0);
  }
  static startCommentsVector(builder, numElems) {
    builder.startVector(8, numElems, 4);
  }
  static endScannedScript(builder) {
    const offset = builder.endObject();
    return offset;
  }
  unpack() {
    return new ScannedScriptT(
      this.externalId(),
      this.bb.createObjList(this.lineBreaks.bind(this), this.lineBreaksLength()),
      this.bb.createObjList(this.errors.bind(this), this.errorsLength()),
      this.tokens() !== null ? this.tokens().unpack() : null,
      this.bb.createObjList(this.comments.bind(this), this.commentsLength())
    );
  }
  unpackTo(_o) {
    _o.externalId = this.externalId();
    _o.lineBreaks = this.bb.createObjList(this.lineBreaks.bind(this), this.lineBreaksLength());
    _o.errors = this.bb.createObjList(this.errors.bind(this), this.errorsLength());
    _o.tokens = this.tokens() !== null ? this.tokens().unpack() : null;
    _o.comments = this.bb.createObjList(this.comments.bind(this), this.commentsLength());
  }
};
var ScannedScriptT = class {
  constructor(externalId = 0, lineBreaks = [], errors = [], tokens = null, comments = []) {
    this.externalId = externalId;
    this.lineBreaks = lineBreaks;
    this.errors = errors;
    this.tokens = tokens;
    this.comments = comments;
  }
  pack(builder) {
    const lineBreaks = builder.createStructOffsetList(this.lineBreaks, ScannedScript.startLineBreaksVector);
    const errors = ScannedScript.createErrorsVector(builder, builder.createObjectOffsetList(this.errors));
    const tokens = this.tokens !== null ? this.tokens.pack(builder) : 0;
    const comments = builder.createStructOffsetList(this.comments, ScannedScript.startCommentsVector);
    ScannedScript.startScannedScript(builder);
    ScannedScript.addExternalId(builder, this.externalId);
    ScannedScript.addLineBreaks(builder, lineBreaks);
    ScannedScript.addErrors(builder, errors);
    ScannedScript.addTokens(builder, tokens);
    ScannedScript.addComments(builder, comments);
    return ScannedScript.endScannedScript(builder);
  }
};

// gen/sqlynx/proto/scanner-token-type.ts
var ScannerTokenType = /* @__PURE__ */ ((ScannerTokenType2) => {
  ScannerTokenType2[ScannerTokenType2["NONE"] = 0] = "NONE";
  ScannerTokenType2[ScannerTokenType2["KEYWORD"] = 1] = "KEYWORD";
  ScannerTokenType2[ScannerTokenType2["LITERAL_INTEGER"] = 2] = "LITERAL_INTEGER";
  ScannerTokenType2[ScannerTokenType2["LITERAL_FLOAT"] = 3] = "LITERAL_FLOAT";
  ScannerTokenType2[ScannerTokenType2["LITERAL_STRING"] = 4] = "LITERAL_STRING";
  ScannerTokenType2[ScannerTokenType2["LITERAL_BINARY"] = 5] = "LITERAL_BINARY";
  ScannerTokenType2[ScannerTokenType2["LITERAL_HEX"] = 6] = "LITERAL_HEX";
  ScannerTokenType2[ScannerTokenType2["LITERAL_BOOLEAN"] = 7] = "LITERAL_BOOLEAN";
  ScannerTokenType2[ScannerTokenType2["OPERATOR"] = 8] = "OPERATOR";
  ScannerTokenType2[ScannerTokenType2["IDENTIFIER"] = 9] = "IDENTIFIER";
  ScannerTokenType2[ScannerTokenType2["COMMENT"] = 10] = "COMMENT";
  return ScannerTokenType2;
})(ScannerTokenType || {});

// gen/sqlynx/proto/script-cursor-info.ts
import * as flatbuffers22 from "flatbuffers";
var ScriptCursorInfo = class _ScriptCursorInfo {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsScriptCursorInfo(bb, obj) {
    return (obj || new _ScriptCursorInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsScriptCursorInfo(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers22.SIZE_PREFIX_LENGTH);
    return (obj || new _ScriptCursorInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  /**
   * The text offset
   */
  textOffset() {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_text_offset(value) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The scanner symbol id
   */
  scannerSymbolId() {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_scanner_symbol_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The offset of the scanner symbol
   */
  scannerSymbolOffset() {
    const offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_scanner_symbol_offset(value) {
    const offset = this.bb.__offset(this.bb_pos, 8);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The kind of the scanner symbol
   */
  scannerSymbolKind() {
    const offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_scanner_symbol_kind(value) {
    const offset = this.bb.__offset(this.bb_pos, 10);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The relative position
   */
  scannerRelativePosition() {
    const offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0 /* NEW_SYMBOL_BEFORE */;
  }
  mutate_scanner_relative_position(value) {
    const offset = this.bb.__offset(this.bb_pos, 12);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint8(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The AST node id
   */
  astNodeId() {
    const offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_ast_node_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 14);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The statement id
   */
  statementId() {
    const offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_statement_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 16);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The table id
   */
  tableId() {
    const offset = this.bb.__offset(this.bb_pos, 18);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_table_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 18);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The table reference id
   */
  tableReferenceId() {
    const offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_table_reference_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 20);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The column reference id
   */
  columnReferenceId() {
    const offset = this.bb.__offset(this.bb_pos, 22);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_column_reference_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 22);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  /**
   * The query edge id
   */
  queryEdgeId() {
    const offset = this.bb.__offset(this.bb_pos, 24);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
  }
  mutate_query_edge_id(value) {
    const offset = this.bb.__offset(this.bb_pos, 24);
    if (offset === 0) {
      return false;
    }
    this.bb.writeUint32(this.bb_pos + offset, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScriptCursorInfo";
  }
  static startScriptCursorInfo(builder) {
    builder.startObject(11);
  }
  static addTextOffset(builder, textOffset) {
    builder.addFieldInt32(0, textOffset, 0);
  }
  static addScannerSymbolId(builder, scannerSymbolId) {
    builder.addFieldInt32(1, scannerSymbolId, 0);
  }
  static addScannerSymbolOffset(builder, scannerSymbolOffset) {
    builder.addFieldInt32(2, scannerSymbolOffset, 0);
  }
  static addScannerSymbolKind(builder, scannerSymbolKind) {
    builder.addFieldInt32(3, scannerSymbolKind, 0);
  }
  static addScannerRelativePosition(builder, scannerRelativePosition) {
    builder.addFieldInt8(4, scannerRelativePosition, 0 /* NEW_SYMBOL_BEFORE */);
  }
  static addAstNodeId(builder, astNodeId) {
    builder.addFieldInt32(5, astNodeId, 0);
  }
  static addStatementId(builder, statementId) {
    builder.addFieldInt32(6, statementId, 0);
  }
  static addTableId(builder, tableId) {
    builder.addFieldInt32(7, tableId, 0);
  }
  static addTableReferenceId(builder, tableReferenceId) {
    builder.addFieldInt32(8, tableReferenceId, 0);
  }
  static addColumnReferenceId(builder, columnReferenceId) {
    builder.addFieldInt32(9, columnReferenceId, 0);
  }
  static addQueryEdgeId(builder, queryEdgeId) {
    builder.addFieldInt32(10, queryEdgeId, 0);
  }
  static endScriptCursorInfo(builder) {
    const offset = builder.endObject();
    return offset;
  }
  static createScriptCursorInfo(builder, textOffset, scannerSymbolId, scannerSymbolOffset, scannerSymbolKind, scannerRelativePosition, astNodeId, statementId, tableId, tableReferenceId, columnReferenceId, queryEdgeId) {
    _ScriptCursorInfo.startScriptCursorInfo(builder);
    _ScriptCursorInfo.addTextOffset(builder, textOffset);
    _ScriptCursorInfo.addScannerSymbolId(builder, scannerSymbolId);
    _ScriptCursorInfo.addScannerSymbolOffset(builder, scannerSymbolOffset);
    _ScriptCursorInfo.addScannerSymbolKind(builder, scannerSymbolKind);
    _ScriptCursorInfo.addScannerRelativePosition(builder, scannerRelativePosition);
    _ScriptCursorInfo.addAstNodeId(builder, astNodeId);
    _ScriptCursorInfo.addStatementId(builder, statementId);
    _ScriptCursorInfo.addTableId(builder, tableId);
    _ScriptCursorInfo.addTableReferenceId(builder, tableReferenceId);
    _ScriptCursorInfo.addColumnReferenceId(builder, columnReferenceId);
    _ScriptCursorInfo.addQueryEdgeId(builder, queryEdgeId);
    return _ScriptCursorInfo.endScriptCursorInfo(builder);
  }
  unpack() {
    return new ScriptCursorInfoT(
      this.textOffset(),
      this.scannerSymbolId(),
      this.scannerSymbolOffset(),
      this.scannerSymbolKind(),
      this.scannerRelativePosition(),
      this.astNodeId(),
      this.statementId(),
      this.tableId(),
      this.tableReferenceId(),
      this.columnReferenceId(),
      this.queryEdgeId()
    );
  }
  unpackTo(_o) {
    _o.textOffset = this.textOffset();
    _o.scannerSymbolId = this.scannerSymbolId();
    _o.scannerSymbolOffset = this.scannerSymbolOffset();
    _o.scannerSymbolKind = this.scannerSymbolKind();
    _o.scannerRelativePosition = this.scannerRelativePosition();
    _o.astNodeId = this.astNodeId();
    _o.statementId = this.statementId();
    _o.tableId = this.tableId();
    _o.tableReferenceId = this.tableReferenceId();
    _o.columnReferenceId = this.columnReferenceId();
    _o.queryEdgeId = this.queryEdgeId();
  }
};
var ScriptCursorInfoT = class {
  constructor(textOffset = 0, scannerSymbolId = 0, scannerSymbolOffset = 0, scannerSymbolKind = 0, scannerRelativePosition = 0 /* NEW_SYMBOL_BEFORE */, astNodeId = 0, statementId = 0, tableId = 0, tableReferenceId = 0, columnReferenceId = 0, queryEdgeId = 0) {
    this.textOffset = textOffset;
    this.scannerSymbolId = scannerSymbolId;
    this.scannerSymbolOffset = scannerSymbolOffset;
    this.scannerSymbolKind = scannerSymbolKind;
    this.scannerRelativePosition = scannerRelativePosition;
    this.astNodeId = astNodeId;
    this.statementId = statementId;
    this.tableId = tableId;
    this.tableReferenceId = tableReferenceId;
    this.columnReferenceId = columnReferenceId;
    this.queryEdgeId = queryEdgeId;
  }
  pack(builder) {
    return ScriptCursorInfo.createScriptCursorInfo(
      builder,
      this.textOffset,
      this.scannerSymbolId,
      this.scannerSymbolOffset,
      this.scannerSymbolKind,
      this.scannerRelativePosition,
      this.astNodeId,
      this.statementId,
      this.tableId,
      this.tableReferenceId,
      this.columnReferenceId,
      this.queryEdgeId
    );
  }
};

// gen/sqlynx/proto/script-processing-memory-statistics.ts
var ScriptProcessingMemoryStatistics = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The size of the scanner input
   */
  scannerInputBytes() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_scanner_input_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 0, value);
    return true;
  }
  /**
   * The size of the scanner symbols
   */
  scannerSymbolBytes() {
    return this.bb.readUint32(this.bb_pos + 4);
  }
  mutate_scanner_symbol_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 4, value);
    return true;
  }
  /**
   * The size of the scanner dictionary
   */
  scannerNameDictionaryBytes() {
    return this.bb.readUint32(this.bb_pos + 8);
  }
  mutate_scanner_name_dictionary_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 8, value);
    return true;
  }
  /**
   * The size of parser ast
   */
  parserAstBytes() {
    return this.bb.readUint32(this.bb_pos + 12);
  }
  mutate_parser_ast_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 12, value);
    return true;
  }
  /**
   * The size of the analyzed script
   */
  analyzerDescriptionBytes() {
    return this.bb.readUint32(this.bb_pos + 16);
  }
  mutate_analyzer_description_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 16, value);
    return true;
  }
  /**
   * The number of entries in the name index
   */
  analyzerNameIndexSize() {
    return this.bb.readUint32(this.bb_pos + 20);
  }
  mutate_analyzer_name_index_size(value) {
    this.bb.writeUint32(this.bb_pos + 20, value);
    return true;
  }
  /**
   * The size of the name index
   */
  analyzerNameIndexBytes() {
    return this.bb.readUint32(this.bb_pos + 24);
  }
  mutate_analyzer_name_index_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 24, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScriptProcessingMemoryStatistics";
  }
  static sizeOf() {
    return 28;
  }
  static createScriptProcessingMemoryStatistics(builder, scanner_input_bytes, scanner_symbol_bytes, scanner_name_dictionary_bytes, parser_ast_bytes, analyzer_description_bytes, analyzer_name_index_size, analyzer_name_index_bytes) {
    builder.prep(4, 28);
    builder.writeInt32(analyzer_name_index_bytes);
    builder.writeInt32(analyzer_name_index_size);
    builder.writeInt32(analyzer_description_bytes);
    builder.writeInt32(parser_ast_bytes);
    builder.writeInt32(scanner_name_dictionary_bytes);
    builder.writeInt32(scanner_symbol_bytes);
    builder.writeInt32(scanner_input_bytes);
    return builder.offset();
  }
  unpack() {
    return new ScriptProcessingMemoryStatisticsT(
      this.scannerInputBytes(),
      this.scannerSymbolBytes(),
      this.scannerNameDictionaryBytes(),
      this.parserAstBytes(),
      this.analyzerDescriptionBytes(),
      this.analyzerNameIndexSize(),
      this.analyzerNameIndexBytes()
    );
  }
  unpackTo(_o) {
    _o.scannerInputBytes = this.scannerInputBytes();
    _o.scannerSymbolBytes = this.scannerSymbolBytes();
    _o.scannerNameDictionaryBytes = this.scannerNameDictionaryBytes();
    _o.parserAstBytes = this.parserAstBytes();
    _o.analyzerDescriptionBytes = this.analyzerDescriptionBytes();
    _o.analyzerNameIndexSize = this.analyzerNameIndexSize();
    _o.analyzerNameIndexBytes = this.analyzerNameIndexBytes();
  }
};
var ScriptProcessingMemoryStatisticsT = class {
  constructor(scannerInputBytes = 0, scannerSymbolBytes = 0, scannerNameDictionaryBytes = 0, parserAstBytes = 0, analyzerDescriptionBytes = 0, analyzerNameIndexSize = 0, analyzerNameIndexBytes = 0) {
    this.scannerInputBytes = scannerInputBytes;
    this.scannerSymbolBytes = scannerSymbolBytes;
    this.scannerNameDictionaryBytes = scannerNameDictionaryBytes;
    this.parserAstBytes = parserAstBytes;
    this.analyzerDescriptionBytes = analyzerDescriptionBytes;
    this.analyzerNameIndexSize = analyzerNameIndexSize;
    this.analyzerNameIndexBytes = analyzerNameIndexBytes;
  }
  pack(builder) {
    return ScriptProcessingMemoryStatistics.createScriptProcessingMemoryStatistics(
      builder,
      this.scannerInputBytes,
      this.scannerSymbolBytes,
      this.scannerNameDictionaryBytes,
      this.parserAstBytes,
      this.analyzerDescriptionBytes,
      this.analyzerNameIndexSize,
      this.analyzerNameIndexBytes
    );
  }
};

// gen/sqlynx/proto/script-memory-statistics.ts
var ScriptMemoryStatistics = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The number of rope bytes
   */
  ropeBytes() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_rope_bytes(value) {
    this.bb.writeUint32(this.bb_pos + 0, value);
    return true;
  }
  /**
   * The memory statistics of the latest script
   */
  latestScript(obj) {
    return (obj || new ScriptProcessingMemoryStatistics()).__init(this.bb_pos + 4, this.bb);
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScriptMemoryStatistics";
  }
  static sizeOf() {
    return 32;
  }
  static createScriptMemoryStatistics(builder, rope_bytes, latest_script_scanner_input_bytes, latest_script_scanner_symbol_bytes, latest_script_scanner_name_dictionary_bytes, latest_script_parser_ast_bytes, latest_script_analyzer_description_bytes, latest_script_analyzer_name_index_size, latest_script_analyzer_name_index_bytes) {
    builder.prep(4, 32);
    builder.prep(4, 28);
    builder.writeInt32(latest_script_analyzer_name_index_bytes);
    builder.writeInt32(latest_script_analyzer_name_index_size);
    builder.writeInt32(latest_script_analyzer_description_bytes);
    builder.writeInt32(latest_script_parser_ast_bytes);
    builder.writeInt32(latest_script_scanner_name_dictionary_bytes);
    builder.writeInt32(latest_script_scanner_symbol_bytes);
    builder.writeInt32(latest_script_scanner_input_bytes);
    builder.writeInt32(rope_bytes);
    return builder.offset();
  }
  unpack() {
    return new ScriptMemoryStatisticsT(
      this.ropeBytes(),
      this.latestScript() !== null ? this.latestScript().unpack() : null
    );
  }
  unpackTo(_o) {
    _o.ropeBytes = this.ropeBytes();
    _o.latestScript = this.latestScript() !== null ? this.latestScript().unpack() : null;
  }
};
var ScriptMemoryStatisticsT = class {
  constructor(ropeBytes = 0, latestScript = null) {
    this.ropeBytes = ropeBytes;
    this.latestScript = latestScript;
  }
  pack(builder) {
    return ScriptMemoryStatistics.createScriptMemoryStatistics(
      builder,
      this.ropeBytes,
      this.latestScript?.scannerInputBytes ?? 0,
      this.latestScript?.scannerSymbolBytes ?? 0,
      this.latestScript?.scannerNameDictionaryBytes ?? 0,
      this.latestScript?.parserAstBytes ?? 0,
      this.latestScript?.analyzerDescriptionBytes ?? 0,
      this.latestScript?.analyzerNameIndexSize ?? 0,
      this.latestScript?.analyzerNameIndexBytes ?? 0
    );
  }
};

// gen/sqlynx/proto/script-processing-timings.ts
var ScriptProcessingTimings = class {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  /**
   * The last duration of the scanner
   */
  scannerLastElapsed() {
    return this.bb.readFloat64(this.bb_pos);
  }
  mutate_scanner_last_elapsed(value) {
    this.bb.writeFloat64(this.bb_pos + 0, value);
    return true;
  }
  /**
   * The last duration of the parser
   */
  parserLastElapsed() {
    return this.bb.readFloat64(this.bb_pos + 8);
  }
  mutate_parser_last_elapsed(value) {
    this.bb.writeFloat64(this.bb_pos + 8, value);
    return true;
  }
  /**
   * The last duration of the analyzer
   */
  analyzerLastElapsed() {
    return this.bb.readFloat64(this.bb_pos + 16);
  }
  mutate_analyzer_last_elapsed(value) {
    this.bb.writeFloat64(this.bb_pos + 16, value);
    return true;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScriptProcessingTimings";
  }
  static sizeOf() {
    return 24;
  }
  static createScriptProcessingTimings(builder, scanner_last_elapsed, parser_last_elapsed, analyzer_last_elapsed) {
    builder.prep(8, 24);
    builder.writeFloat64(analyzer_last_elapsed);
    builder.writeFloat64(parser_last_elapsed);
    builder.writeFloat64(scanner_last_elapsed);
    return builder.offset();
  }
  unpack() {
    return new ScriptProcessingTimingsT(
      this.scannerLastElapsed(),
      this.parserLastElapsed(),
      this.analyzerLastElapsed()
    );
  }
  unpackTo(_o) {
    _o.scannerLastElapsed = this.scannerLastElapsed();
    _o.parserLastElapsed = this.parserLastElapsed();
    _o.analyzerLastElapsed = this.analyzerLastElapsed();
  }
};
var ScriptProcessingTimingsT = class {
  constructor(scannerLastElapsed = 0, parserLastElapsed = 0, analyzerLastElapsed = 0) {
    this.scannerLastElapsed = scannerLastElapsed;
    this.parserLastElapsed = parserLastElapsed;
    this.analyzerLastElapsed = analyzerLastElapsed;
  }
  pack(builder) {
    return ScriptProcessingTimings.createScriptProcessingTimings(
      builder,
      this.scannerLastElapsed,
      this.parserLastElapsed,
      this.analyzerLastElapsed
    );
  }
};

// gen/sqlynx/proto/script-statistics.ts
import * as flatbuffers23 from "flatbuffers";
var ScriptStatistics = class _ScriptStatistics {
  constructor() {
    this.bb = null;
    this.bb_pos = 0;
  }
  __init(i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }
  static getRootAsScriptStatistics(bb, obj) {
    return (obj || new _ScriptStatistics()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  static getSizePrefixedRootAsScriptStatistics(bb, obj) {
    bb.setPosition(bb.position() + flatbuffers23.SIZE_PREFIX_LENGTH);
    return (obj || new _ScriptStatistics()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
  /**
   * The analyzer statistics
   */
  timings(obj) {
    const offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? (obj || new ScriptProcessingTimings()).__init(this.bb_pos + offset, this.bb) : null;
  }
  /**
   * The memory statistics
   */
  memory(obj) {
    const offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? (obj || new ScriptMemoryStatistics()).__init(this.bb_pos + offset, this.bb) : null;
  }
  static getFullyQualifiedName() {
    return "sqlynx.proto.ScriptStatistics";
  }
  static startScriptStatistics(builder) {
    builder.startObject(2);
  }
  static addTimings(builder, timingsOffset) {
    builder.addFieldStruct(0, timingsOffset, 0);
  }
  static addMemory(builder, memoryOffset) {
    builder.addFieldStruct(1, memoryOffset, 0);
  }
  static endScriptStatistics(builder) {
    const offset = builder.endObject();
    return offset;
  }
  unpack() {
    return new ScriptStatisticsT(
      this.timings() !== null ? this.timings().unpack() : null,
      this.memory() !== null ? this.memory().unpack() : null
    );
  }
  unpackTo(_o) {
    _o.timings = this.timings() !== null ? this.timings().unpack() : null;
    _o.memory = this.memory() !== null ? this.memory().unpack() : null;
  }
};
var ScriptStatisticsT = class {
  constructor(timings = null, memory = null) {
    this.timings = timings;
    this.memory = memory;
  }
  pack(builder) {
    ScriptStatistics.startScriptStatistics(builder);
    ScriptStatistics.addTimings(builder, this.timings !== null ? this.timings.pack(builder) : 0);
    ScriptStatistics.addMemory(builder, this.memory !== null ? this.memory.pack(builder) : 0);
    return ScriptStatistics.endScriptStatistics(builder);
  }
};

// gen/sqlynx/proto/status-code.ts
var StatusCode = /* @__PURE__ */ ((StatusCode2) => {
  StatusCode2[StatusCode2["OK"] = 1] = "OK";
  StatusCode2[StatusCode2["CATALOG_SCRIPT_NOT_ANALYZED"] = 3] = "CATALOG_SCRIPT_NOT_ANALYZED";
  StatusCode2[StatusCode2["CATALOG_SCRIPT_UNKNOWN"] = 4] = "CATALOG_SCRIPT_UNKNOWN";
  StatusCode2[StatusCode2["CATALOG_DESCRIPTOR_POOL_UNKNOWN"] = 5] = "CATALOG_DESCRIPTOR_POOL_UNKNOWN";
  StatusCode2[StatusCode2["CATALOG_DESCRIPTOR_TABLES_NULL"] = 6] = "CATALOG_DESCRIPTOR_TABLES_NULL";
  StatusCode2[StatusCode2["CATALOG_DESCRIPTOR_TABLE_NAME_EMPTY"] = 7] = "CATALOG_DESCRIPTOR_TABLE_NAME_EMPTY";
  StatusCode2[StatusCode2["CATALOG_DESCRIPTOR_TABLE_NAME_COLLISION"] = 8] = "CATALOG_DESCRIPTOR_TABLE_NAME_COLLISION";
  StatusCode2[StatusCode2["PARSER_INPUT_NOT_SCANNED"] = 10] = "PARSER_INPUT_NOT_SCANNED";
  StatusCode2[StatusCode2["ANALYZER_INPUT_NOT_PARSED"] = 11] = "ANALYZER_INPUT_NOT_PARSED";
  StatusCode2[StatusCode2["GRAPH_INPUT_NOT_ANALYZED"] = 12] = "GRAPH_INPUT_NOT_ANALYZED";
  StatusCode2[StatusCode2["EXTERNAL_ID_COLLISION"] = 20] = "EXTERNAL_ID_COLLISION";
  StatusCode2[StatusCode2["COMPLETION_MISSES_CURSOR"] = 30] = "COMPLETION_MISSES_CURSOR";
  StatusCode2[StatusCode2["COMPLETION_MISSES_SCANNER_TOKEN"] = 31] = "COMPLETION_MISSES_SCANNER_TOKEN";
  return StatusCode2;
})(StatusCode || {});

// gen/sqlynx/proto/subquery-quantifier.ts
var SubqueryQuantifier = /* @__PURE__ */ ((SubqueryQuantifier2) => {
  SubqueryQuantifier2[SubqueryQuantifier2["ANY"] = 0] = "ANY";
  SubqueryQuantifier2[SubqueryQuantifier2["SOME"] = 1] = "SOME";
  SubqueryQuantifier2[SubqueryQuantifier2["ALL"] = 2] = "ALL";
  return SubqueryQuantifier2;
})(SubqueryQuantifier || {});

// gen/sqlynx/proto/table-constraint.ts
var TableConstraint = /* @__PURE__ */ ((TableConstraint2) => {
  TableConstraint2[TableConstraint2["CHECK"] = 0] = "CHECK";
  TableConstraint2[TableConstraint2["UNIQUE"] = 1] = "UNIQUE";
  TableConstraint2[TableConstraint2["PRIMARY_KEY"] = 2] = "PRIMARY_KEY";
  TableConstraint2[TableConstraint2["FOREIGN_KEY"] = 3] = "FOREIGN_KEY";
  return TableConstraint2;
})(TableConstraint || {});

// gen/sqlynx/proto/temp-type.ts
var TempType = /* @__PURE__ */ ((TempType2) => {
  TempType2[TempType2["NONE"] = 0] = "NONE";
  TempType2[TempType2["DEFAULT"] = 1] = "DEFAULT";
  TempType2[TempType2["GLOBAL"] = 2] = "GLOBAL";
  TempType2[TempType2["LOCAL"] = 3] = "LOCAL";
  TempType2[TempType2["UNLOGGED"] = 4] = "UNLOGGED";
  return TempType2;
})(TempType || {});

// gen/sqlynx/proto/trim-direction.ts
var TrimDirection = /* @__PURE__ */ ((TrimDirection2) => {
  TrimDirection2[TrimDirection2["BOTH"] = 0] = "BOTH";
  TrimDirection2[TrimDirection2["LEADING"] = 1] = "LEADING";
  TrimDirection2[TrimDirection2["TRAILING"] = 2] = "TRAILING";
  return TrimDirection2;
})(TrimDirection || {});

// gen/sqlynx/proto/window-bound-direction.ts
var WindowBoundDirection = /* @__PURE__ */ ((WindowBoundDirection2) => {
  WindowBoundDirection2[WindowBoundDirection2["PRECEDING"] = 0] = "PRECEDING";
  WindowBoundDirection2[WindowBoundDirection2["FOLLOWING"] = 1] = "FOLLOWING";
  return WindowBoundDirection2;
})(WindowBoundDirection || {});

// gen/sqlynx/proto/window-bound-mode.ts
var WindowBoundMode = /* @__PURE__ */ ((WindowBoundMode2) => {
  WindowBoundMode2[WindowBoundMode2["UNBOUNDED"] = 0] = "UNBOUNDED";
  WindowBoundMode2[WindowBoundMode2["CURRENT_ROW"] = 1] = "CURRENT_ROW";
  WindowBoundMode2[WindowBoundMode2["VALUE"] = 2] = "VALUE";
  return WindowBoundMode2;
})(WindowBoundMode || {});

// gen/sqlynx/proto/window-exclusion-mode.ts
var WindowExclusionMode = /* @__PURE__ */ ((WindowExclusionMode2) => {
  WindowExclusionMode2[WindowExclusionMode2["CURRENT_ROW"] = 0] = "CURRENT_ROW";
  WindowExclusionMode2[WindowExclusionMode2["GROUP"] = 1] = "GROUP";
  WindowExclusionMode2[WindowExclusionMode2["TIES"] = 2] = "TIES";
  return WindowExclusionMode2;
})(WindowExclusionMode || {});

// gen/sqlynx/proto/window-range-mode.ts
var WindowRangeMode = /* @__PURE__ */ ((WindowRangeMode2) => {
  WindowRangeMode2[WindowRangeMode2["RANGE"] = 0] = "RANGE";
  WindowRangeMode2[WindowRangeMode2["ROWS"] = 1] = "ROWS";
  WindowRangeMode2[WindowRangeMode2["GROUPS"] = 2] = "GROUPS";
  return WindowRangeMode2;
})(WindowRangeMode || {});

// src/api.ts
import * as flatbuffers24 from "flatbuffers";
var SCRIPT_TYPE = Symbol("SCRIPT_TYPE");
var CATALOG_TYPE = Symbol("CATALOG_TYPE");
var GRAPH_LAYOUT_TYPE = Symbol("GRAPH_LAYOUT_TYPE");
var SQLynx = class _SQLynx {
  constructor(instance) {
    this.encoder = new TextEncoder();
    this.decoder = new TextDecoder();
    this.instance = instance;
    this.memory = instance.exports["memory"];
    this.instanceExports = {
      sqlynx_version: instance.exports["sqlynx_version"],
      sqlynx_malloc: instance.exports["sqlynx_malloc"],
      sqlynx_free: instance.exports["sqlynx_free"],
      sqlynx_delete_result: instance.exports["sqlynx_delete_result"],
      sqlynx_script_new: instance.exports["sqlynx_script_new"],
      sqlynx_catalog_clear: instance.exports["sqlynx_catalog_clear"],
      sqlynx_script_insert_text_at: instance.exports["sqlynx_script_insert_text_at"],
      sqlynx_script_insert_char_at: instance.exports["sqlynx_script_insert_char_at"],
      sqlynx_script_erase_text_range: instance.exports["sqlynx_script_erase_text_range"],
      sqlynx_script_replace_text: instance.exports["sqlynx_script_replace_text"],
      sqlynx_script_to_string: instance.exports["sqlynx_script_to_string"],
      sqlynx_script_format: instance.exports["sqlynx_script_format"],
      sqlynx_script_scan: instance.exports["sqlynx_script_scan"],
      sqlynx_script_parse: instance.exports["sqlynx_script_parse"],
      sqlynx_script_analyze: instance.exports["sqlynx_script_analyze"],
      sqlynx_script_get_statistics: instance.exports["sqlynx_script_get_statistics"],
      sqlynx_script_move_cursor: instance.exports["sqlynx_script_move_cursor"],
      sqlynx_script_complete_at_cursor: instance.exports["sqlynx_script_complete_at_cursor"],
      sqlynx_catalog_new: instance.exports["sqlynx_catalog_new"],
      sqlynx_catalog_describe_entries: instance.exports["sqlynx_catalog_describe_entries"],
      sqlynx_catalog_describe_entries_of: instance.exports["sqlynx_catalog_describe_entries_of"],
      sqlynx_catalog_load_script: instance.exports["sqlynx_catalog_load_script"],
      sqlynx_catalog_update_script: instance.exports["sqlynx_catalog_update_script"],
      sqlynx_catalog_drop_script: instance.exports["sqlynx_catalog_drop_script"],
      sqlynx_catalog_add_descriptor_pool: instance.exports["sqlynx_catalog_add_descriptor_pool"],
      sqlynx_catalog_drop_descriptor_pool: instance.exports["sqlynx_catalog_drop_descriptor_pool"],
      sqlynx_catalog_add_schema_descriptor: instance.exports["sqlynx_catalog_add_schema_descriptor"],
      sqlynx_query_graph_layout_new: instance.exports["sqlynx_query_graph_layout_new"],
      sqlynx_query_graph_layout_configure: instance.exports["sqlynx_query_graph_layout_configure"],
      sqlynx_query_graph_layout_load_script: instance.exports["sqlynx_query_graph_layout_load_script"]
    };
  }
  static async create(instantiate) {
    const instanceRef = { instance: null };
    const importStubs = {
      wasi_snapshot_preview1: {
        proc_exit: (code) => console.error(`proc_exit(${code})`),
        environ_sizes_get: () => console.error(`environ_sizes_get()`),
        environ_get: (environ, buf) => console.error(`environ_get(${environ}, ${buf})`),
        fd_fdstat_get: (fd) => console.error(`fd_fdstat_get(${fd})`),
        fd_seek: (fd, offset, whence) => console.error(`fd_seek(${fd}, ${offset}, ${whence})`),
        fd_write: (fd, iovs) => console.error(`fd_write(${fd}, ${iovs})`),
        fd_read: (fd, iovs) => console.error(`fd_read(${fd}, ${iovs})`),
        fd_close: (fd) => console.error(`fd_close(${fd})`),
        clock_time_get: (_id, _precision, ptr) => {
          const instance2 = instanceRef.instance;
          const buffer = new BigUint64Array(instance2.memory.buffer);
          const nowMs = performance.now();
          const nowNs = BigInt(Math.floor(nowMs * 1e3 * 1e3));
          buffer[ptr / 8] = nowNs;
          return 0;
        }
      },
      env: {
        log: (text, textLength) => {
          const instance2 = instanceRef.instance;
          const textBuffer = new Uint8Array(instance2.memory.buffer.slice(text, text + textLength));
          console.log(instance2.decoder.decode(textBuffer));
        }
      }
    };
    const streaming = await instantiate(importStubs);
    const instance = streaming.instance;
    const startFn = instance.exports["_start"];
    startFn();
    instanceRef.instance = new _SQLynx(instance);
    return instanceRef.instance;
  }
  copyString(text) {
    if (text.length == 0) {
      return [0, 0];
    }
    const textBegin = this.instanceExports.sqlynx_malloc(text.length * 3);
    if (textBegin == 0) {
      throw new Error(`failed to allocate a string of size ${text.length}`);
    }
    const textBuffer = new Uint8Array(this.memory.buffer).subarray(textBegin, textBegin + text.length * 3);
    const textEncoded = this.encoder.encodeInto(text, textBuffer);
    if (textEncoded.written == void 0 || textEncoded.written == 0) {
      this.instanceExports.sqlynx_free(textBegin);
      throw new Error(`failed to encode a string of size ${text.length}`);
    }
    return [textBegin, textEncoded.written];
  }
  copyBuffer(src) {
    if (src.length == 0) {
      return [0, 0];
    }
    const ptr = this.instanceExports.sqlynx_malloc(src.length);
    if (ptr == 0) {
      throw new Error(`failed to allocate a buffer of size ${src.length}`);
    }
    const dst = new Uint8Array(this.memory.buffer).subarray(ptr, ptr + src.length);
    dst.set(src);
    return [ptr, src.length];
  }
  createScript(catalog, id, databaseName = null, schemaName = null) {
    if (id == 4294967295) {
      throw new Error("context id 0xFFFFFFFF is reserved");
    }
    let databaseNamePtr = 0, databaseNameLength = 0, schemaNamePtr = 0, schemaNameLength = 0;
    if (databaseName != null) {
      [databaseNamePtr, databaseNameLength] = this.copyString(databaseName);
    }
    if (schemaName != null) {
      try {
        [schemaNamePtr, schemaNameLength] = this.copyString(schemaName);
      } catch (e) {
        this.instanceExports.sqlynx_free(databaseNamePtr);
        throw e;
      }
    }
    const catalogPtr = catalog?.ptr.assertNotNull() ?? 0;
    const result = this.instanceExports.sqlynx_script_new(
      catalogPtr,
      id,
      databaseNamePtr,
      // pass ownership over buffer
      databaseNameLength,
      schemaNamePtr,
      // pass ownership over buffer
      schemaNameLength
    );
    const scriptPtr = this.readPtrResult(SCRIPT_TYPE, result);
    return new SQLynxScript(scriptPtr);
  }
  createCatalog() {
    const result = this.instanceExports.sqlynx_catalog_new();
    const ptr = this.readPtrResult(CATALOG_TYPE, result);
    return new SQLynxCatalog(ptr);
  }
  createQueryGraphLayout() {
    const result = this.instanceExports.sqlynx_query_graph_layout_new();
    const ptr = this.readPtrResult(GRAPH_LAYOUT_TYPE, result);
    return new SQLynxQueryGraphLayout(ptr);
  }
  getVersionText() {
    const versionPtr = this.instanceExports.sqlynx_version();
    const heapU8 = new Uint8Array(this.memory.buffer);
    const heapU32 = new Uint32Array(this.memory.buffer);
    const dataPtr = heapU32[versionPtr / 4];
    const dataLength = heapU32[versionPtr / 4 + 1];
    const dataArray = heapU8.subarray(dataPtr, dataPtr + dataLength);
    return this.decoder.decode(dataArray);
  }
  readPtrResult(ptrType, resultPtr) {
    const heapU8 = new Uint8Array(this.memory.buffer);
    const resultPtrU32 = resultPtr / 4;
    const heapU32 = new Uint32Array(this.memory.buffer);
    const statusCode = heapU32[resultPtrU32];
    if (statusCode == 1 /* OK */) {
      const ownerPtr = heapU32[resultPtrU32 + 3];
      return new Ptr(ptrType, this, resultPtr, ownerPtr);
    } else {
      const dataLength = heapU32[resultPtrU32 + 1];
      const dataPtr = heapU32[resultPtrU32 + 2];
      const dataArray = heapU8.subarray(dataPtr, dataPtr + dataLength);
      const error = this.decoder.decode(dataArray);
      this.instanceExports.sqlynx_delete_result(resultPtr);
      throw new Error(error);
    }
  }
  readFlatBufferResult(resultPtr) {
    const heapU8 = new Uint8Array(this.memory.buffer);
    const resultPtrU32 = resultPtr / 4;
    const heapU32 = new Uint32Array(this.memory.buffer);
    const statusCode = heapU32[resultPtrU32];
    const dataLength = heapU32[resultPtrU32 + 1];
    const dataPtr = heapU32[resultPtrU32 + 2];
    if (statusCode == 1 /* OK */) {
      return new FlatBufferPtr(this, resultPtr, dataPtr, dataLength);
    } else {
      const dataArray = heapU8.subarray(dataPtr, dataPtr + dataLength);
      const error = this.decoder.decode(dataArray);
      this.instanceExports.sqlynx_delete_result(resultPtr);
      throw new Error(error);
    }
  }
  readStatusResult(resultPtr) {
    const heapU8 = new Uint8Array(this.memory.buffer);
    const resultPtrU32 = resultPtr / 4;
    const heapU32 = new Uint32Array(this.memory.buffer);
    const statusCode = heapU32[resultPtrU32];
    const dataLength = heapU32[resultPtrU32 + 1];
    const dataPtr = heapU32[resultPtrU32 + 2];
    if (statusCode == 1 /* OK */) {
      this.instanceExports.sqlynx_delete_result(resultPtr);
    } else {
      const dataArray = heapU8.subarray(dataPtr, dataPtr + dataLength);
      const error = this.decoder.decode(dataArray);
      this.instanceExports.sqlynx_delete_result(resultPtr);
      throw new Error(error);
    }
  }
};
var NULL_POINTER_EXCEPTION = new Error("tried to access a null pointer");
var Ptr = class {
  constructor(type, api, resultPtr, ownerPtr) {
    this.type = type;
    this.api = api;
    this.ptr = ownerPtr;
    this.resultPtr = resultPtr;
  }
  /// Delete the object
  delete() {
    if (this.resultPtr != null) {
      this.api.instanceExports.sqlynx_delete_result(this.resultPtr);
      this.resultPtr = null;
    }
  }
  /// Make sure the pointer is not null
  assertNotNull() {
    if (this.resultPtr == null) {
      throw NULL_POINTER_EXCEPTION;
    }
    return this.ptr;
  }
  /// Is null?
  isNull() {
    return this.resultPtr != null;
  }
  /// Get the object pointer
  get() {
    return this.ptr;
  }
};
var FlatBufferPtr = class {
  constructor(api, resultPtr, dataPtr, dataLength) {
    this.api = api;
    this.resultPtr = resultPtr;
    this.dataPtr = dataPtr;
    this.dataLength = dataLength;
  }
  /// Delete the buffer
  delete() {
    if (this.resultPtr) {
      this.api.instanceExports.sqlynx_delete_result(this.resultPtr);
    }
    this.resultPtr = null;
  }
  /// Get the data
  get data() {
    const begin = this.dataPtr ?? 0;
    return new Uint8Array(this.api.memory.buffer).subarray(begin, begin + this.dataLength);
  }
  /// Copy the data into a buffer
  copy() {
    const copy = new Uint8Array(new ArrayBuffer(this.data.byteLength));
    copy.set(this.data);
    return copy;
  }
  // Get the flatbuffer object
  // C.f. getRootAsAnalyzedScript
  read(obj) {
    const bb = new flatbuffers24.ByteBuffer(this.data);
    return obj.__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }
};
var SQLynxScript = class {
  constructor(ptr) {
    this.ptr = ptr;
  }
  /// Delete a graph
  delete() {
    this.ptr.delete();
  }
  /// Insert text at an offset
  insertTextAt(offset, text) {
    const scriptPtr = this.ptr.assertNotNull();
    if (text.length == 1) {
      this.ptr.api.instanceExports.sqlynx_script_insert_char_at(scriptPtr, offset, text.charCodeAt(0));
      return;
    }
    const [textBegin, textLength] = this.ptr.api.copyString(text);
    this.ptr.api.instanceExports.sqlynx_script_insert_text_at(scriptPtr, offset, textBegin, textLength);
  }
  /// Earse a range of characters
  eraseTextRange(offset, length) {
    const scriptPtr = this.ptr.assertNotNull();
    this.ptr.api.instanceExports.sqlynx_script_erase_text_range(scriptPtr, offset, length);
  }
  /// Replace the text text
  replaceText(text) {
    const scriptPtr = this.ptr.assertNotNull();
    const [textBegin, textLength] = this.ptr.api.copyString(text);
    this.ptr.api.instanceExports.sqlynx_script_replace_text(scriptPtr, textBegin, textLength);
  }
  /// Convert a rope to a string
  toString() {
    const scriptPtr = this.ptr.assertNotNull();
    const result = this.ptr.api.instanceExports.sqlynx_script_to_string(scriptPtr);
    const resultBuffer = this.ptr.api.readFlatBufferResult(result);
    const text = this.ptr.api.decoder.decode(resultBuffer.data);
    resultBuffer.delete();
    return text;
  }
  /// Parse the script
  scan() {
    const scriptPtr = this.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_script_scan(scriptPtr);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
  /// Parse the script
  parse() {
    const scriptPtr = this.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_script_parse(scriptPtr);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
  /// Analyze the script (optionally with an external script)
  analyze() {
    const scriptPtr = this.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_script_analyze(scriptPtr);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
  /// Pretty print the SQL string
  format() {
    const scriptPtr = this.ptr.assertNotNull();
    const result = this.ptr.api.instanceExports.sqlynx_script_format(scriptPtr);
    const resultBuffer = this.ptr.api.readFlatBufferResult(result);
    const text = this.ptr.api.decoder.decode(resultBuffer.data);
    resultBuffer.delete();
    return text;
  }
  /// Move the cursor
  moveCursor(textOffset) {
    const scriptPtr = this.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_script_move_cursor(scriptPtr, textOffset);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
  /// Complete at the cursor position
  completeAtCursor(limit) {
    const scriptPtr = this.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_script_complete_at_cursor(scriptPtr, limit);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
  /// Get the script statistics.
  /// Timings are useless in some browsers today.
  /// For example, Firefox rounds to millisecond precision, so all our step timings will be 0 for most input.
  /// One way out might be COEP but we cannot easily set that with GitHub pages.
  /// https://developer.mozilla.org/en-US/docs/Web/API/Performance_API/High_precision_timing#reduced_precision
  getStatistics() {
    const scriptPtr = this.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_script_get_statistics(scriptPtr);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
};
var SQLynxCatalog = class {
  constructor(ptr) {
    this.ptr = ptr;
  }
  /// Delete the graph
  delete() {
    this.ptr.delete();
  }
  /// Reset a catalog
  clear() {
    const catalogPtr = this.ptr.assertNotNull();
    this.ptr.api.instanceExports.sqlynx_catalog_clear(catalogPtr);
  }
  /// Describe catalog entries
  describeEntries() {
    const catalogPtr = this.ptr.assertNotNull();
    const result = this.ptr.api.instanceExports.sqlynx_catalog_describe_entries(catalogPtr);
    return this.ptr.api.readFlatBufferResult(result);
  }
  /// Describe catalog entries
  describeEntriesOf(id) {
    const catalogPtr = this.ptr.assertNotNull();
    const result = this.ptr.api.instanceExports.sqlynx_catalog_describe_entries_of(catalogPtr, id);
    return this.ptr.api.readFlatBufferResult(result);
  }
  /// Add a script in the registry
  loadScript(script, rank) {
    const catalogPtr = this.ptr.assertNotNull();
    const scriptPtr = script.ptr.assertNotNull();
    const result = this.ptr.api.instanceExports.sqlynx_catalog_load_script(catalogPtr, scriptPtr, rank);
    this.ptr.api.readStatusResult(result);
  }
  /// Update a script from the registry
  dropScript(script) {
    const catalogPtr = this.ptr.assertNotNull();
    const scriptPtr = script.ptr.assertNotNull();
    this.ptr.api.instanceExports.sqlynx_catalog_drop_script(catalogPtr, scriptPtr);
  }
  /// Add an external schema
  addDescriptorPool(id, rank) {
    const catalogPtr = this.ptr.assertNotNull();
    const result = this.ptr.api.instanceExports.sqlynx_catalog_add_descriptor_pool(catalogPtr, id, rank);
    this.ptr.api.readStatusResult(result);
  }
  /// Drop an external schema
  dropDescriptorPool(id) {
    const catalogPtr = this.ptr.assertNotNull();
    this.ptr.api.instanceExports.sqlynx_catalog_drop_script(catalogPtr, id);
  }
  /// Add a schema descriptor to a descriptor pool
  addSchemaDescriptor(id, buffer) {
    const catalogPtr = this.ptr.assertNotNull();
    const [bufferPtr, bufferLength] = this.ptr.api.copyBuffer(buffer);
    const result = this.ptr.api.instanceExports.sqlynx_catalog_add_schema_descriptor(
      catalogPtr,
      id,
      bufferPtr,
      // pass ownership over buffer
      bufferLength
    );
    this.ptr.api.readStatusResult(result);
  }
  /// Add a schema descriptor to a descriptor pool
  addSchemaDescriptorT(id, descriptor) {
    const builder = new flatbuffers24.Builder();
    const descriptorOffset = descriptor.pack(builder);
    builder.finish(descriptorOffset);
    const buffer = builder.asUint8Array();
    this.addSchemaDescriptor(id, buffer);
  }
};
var SQLynxQueryGraphLayout = class {
  constructor(ptr) {
    this.ptr = ptr;
  }
  /// Delete the graph
  delete() {
    this.ptr.delete();
  }
  /// Configure the graph
  configure(config) {
    const ptr = this.ptr.assertNotNull();
    this.ptr.api.instanceExports.sqlynx_query_graph_layout_configure(
      ptr,
      config.boardWidth,
      config.boardHeight,
      config.cellWidth,
      config.cellHeight,
      config.tableWidth,
      config.tableHeight
    );
  }
  /// Load a script
  loadScript(script) {
    const ptr = this.ptr.assertNotNull();
    const scriptPtr = script.ptr.assertNotNull();
    const resultPtr = this.ptr.api.instanceExports.sqlynx_query_graph_layout_load_script(ptr, scriptPtr);
    return this.ptr.api.readFlatBufferResult(resultPtr);
  }
};
var ExternalObjectID;
((ExternalObjectID2) => {
  function create(context, value) {
    if (context == 4294967295) {
      throw new Error("context id 0xFFFFFFFF is reserved");
    }
    return BigInt(context) << 32n | BigInt(value);
  }
  ExternalObjectID2.create = create;
  function getExternalID(value) {
    return Number(value >> 32n);
  }
  ExternalObjectID2.getExternalID = getExternalID;
  function getObjectID(value) {
    return Number(value & 0xffffffffn);
  }
  ExternalObjectID2.getObjectID = getObjectID;
  function isNull(value) {
    return ExternalObjectID2.getObjectID(value) == 4294967295;
  }
  ExternalObjectID2.isNull = isNull;
})(ExternalObjectID || (ExternalObjectID = {}));

// src/tokens.ts
function lowerBound(values, target, begin, end) {
  let count = end - begin;
  while (count > 0) {
    const step = count >>> 1;
    const it = begin + step;
    if (values[it] < target) {
      begin = it + 1;
      count -= step + 1;
    } else {
      count = step;
    }
  }
  return begin;
}
function findTokensInRange(hl, begin, end) {
  const offsets = hl.tokenOffsetsArray();
  if ((offsets?.length ?? 0) === 0) {
    return [0, 0];
  }
  let lb = lowerBound(offsets, begin, 0, offsets.length);
  lb = offsets[lb] > begin && lb > 0 ? lb - 1 : lb;
  const ub = lowerBound(offsets, end, lb, offsets.length);
  return [lb, ub];
}
export {
  ExternalObjectID,
  FlatBufferPtr,
  NULL_POINTER_EXCEPTION,
  Ptr,
  SQLynx,
  SQLynxCatalog,
  SQLynxQueryGraphLayout,
  SQLynxScript,
  findTokensInRange,
  proto_exports as proto
};
//# sourceMappingURL=sqlynx.module.js.map
